var cartNoteTyping;

validateQty = function (qty) {
  if (parseFloat(qty) == parseInt(qty) && !isNaN(qty)) {
    // We have a valid number!
  } else {
    // Not a number. Default to 1.
    qty = 1;
  }
  return qty;
};

const countryList = {
  AF: "Afghanistan",
  AX: "Aland Islands",
  AL: "Albania",
  DZ: "Algeria",
  AS: "American Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarctica",
  AG: "Antigua and Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaijan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Belgium",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BQ: "Bonaire, Sint Eustatius and Saba",
  BA: "Bosnia and Herzegovina",
  BW: "Botswana",
  BV: "Bouvet Island",
  BR: "Brazil",
  IO: "British Indian Ocean Territory",
  BN: "Brunei Darussalam",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Cambodia",
  CM: "Cameroon",
  CA: "Canada",
  CV: "Cape Verde",
  KY: "Cayman Islands",
  CF: "Central African Republic",
  TD: "Chad",
  CL: "Chile",
  CN: "China",
  CX: "Christmas Island",
  CC: "Cocos (Keeling) Islands",
  CO: "Colombia",
  KM: "Comoros",
  CG: "Congo",
  CD: "Congo, the Democratic Republic of the",
  CK: "Cook Islands",
  CR: "Costa Rica",
  CI: "Cote D'Ivoire",
  HR: "Croatia",
  CU: "Cuba",
  CW: "Curacao",
  CY: "Cyprus",
  CZ: "Czech Republic",
  DK: "Denmark",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominican Republic",
  EC: "Ecuador",
  EG: "Egypt",
  SV: "El Salvador",
  GQ: "Equatorial Guinea",
  ER: "Eritrea",
  EE: "Estonia",
  ET: "Ethiopia",
  FK: "Falkland Islands (Malvinas)",
  FO: "Faroe Islands",
  FJ: "Fiji",
  FI: "Finland",
  FR: "France",
  GF: "French Guiana",
  PF: "French Polynesia",
  TF: "French Southern Territories",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Germany",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Greece",
  GL: "Greenland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GG: "Guernsey",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard Island and Mcdonald Islands",
  VA: "Holy See (Vatican City State)",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hungary",
  IS: "Iceland",
  IN: "India",
  ID: "Indonesia",
  IR: "Iran, Islamic Republic of",
  IQ: "Iraq",
  IE: "Ireland",
  IM: "Isle of Man",
  IL: "Israel",
  IT: "Italy",
  JM: "Jamaica",
  JP: "Japan",
  JE: "Jersey",
  JO: "Jordan",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KP: "Korea, Democratic People's Republic of",
  KR: "Korea, Republic of",
  XK: "Kosovo",
  KW: "Kuwait",
  KG: "Kyrgyzstan",
  LA: "Lao People's Democratic Republic",
  LV: "Latvia",
  LB: "Lebanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libyan Arab Jamahiriya",
  LI: "Liechtenstein",
  LT: "Lithuania",
  LU: "Luxembourg",
  MO: "Macao",
  MK: "Macedonia, the Former Yugoslav Republic of",
  MG: "Madagascar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldives",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshall Islands",
  MQ: "Martinique",
  MR: "Mauritania",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  FM: "Micronesia, Federated States of",
  MD: "Moldova, Republic of",
  MC: "Monaco",
  MN: "Mongolia",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Morocco",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Netherlands",
  AN: "Netherlands Antilles",
  NC: "New Caledonia",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk Island",
  MP: "Northern Mariana Islands",
  NO: "Norway",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Palestinian Territory, Occupied",
  PA: "Panama",
  PG: "Papua New Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Philippines",
  PN: "Pitcairn",
  PL: "Poland",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  RE: "Reunion",
  RO: "Romania",
  RU: "Russian Federation",
  RW: "Rwanda",
  BL: "Saint Barthelemy",
  SH: "Saint Helena",
  KN: "Saint Kitts and Nevis",
  LC: "Saint Lucia",
  MF: "Saint Martin",
  PM: "Saint Pierre and Miquelon",
  VC: "Saint Vincent and the Grenadines",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Sao Tome and Principe",
  SA: "Saudi Arabia",
  SN: "Senegal",
  RS: "Serbia",
  CS: "Serbia and Montenegro",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapore",
  SX: "Sint Maarten",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Solomon Islands",
  SO: "Somalia",
  ZA: "South Africa",
  GS: "South Georgia and the South Sandwich Islands",
  SS: "South Sudan",
  ES: "Spain",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Suriname",
  SJ: "Svalbard and Jan Mayen",
  SZ: "Swaziland",
  SE: "Sweden",
  CH: "Switzerland",
  SY: "Syrian Arab Republic",
  TW: "Taiwan, Province of China",
  TJ: "Tajikistan",
  TZ: "Tanzania, United Republic of",
  TH: "Thailand",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad and Tobago",
  TN: "Tunisia",
  TR: "Turkey",
  TM: "Turkmenistan",
  TC: "Turks and Caicos Islands",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraine",
  AE: "United Arab Emirates",
  GB: "United Kingdom",
  US: "United States",
  UM: "United States Minor Outlying Islands",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Viet Nam",
  VG: "Virgin Islands, British",
  VI: "Virgin Islands, U.s.",
  WF: "Wallis and Futuna",
  EH: "Western Sahara",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
};

let convertShippingAmount = freeShippingBarAmount;
function checkShippingAvailablity() {
  let selectedCountry = Shopify.country;
  let shippingCountriesContainer = $("#shippingcountries");
  if (shippingCountriesContainer.length == 0) {
    shippingCountriesContainer = $("#shippingCountry");
  }
  if (
    shippingCountriesContainer &&
    shippingCountriesContainer.find("option").length > 0
  ) {
    let shippingSelectedCountry = countryList[selectedCountry];
    if (
      shippingCountriesContainer.find(
        'option[value="' + shippingSelectedCountry + '"]'
      ).length > 0
    ) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}

function freeShippingBar(cart) {
  let countryAvailable = checkShippingAvailablity();
  let shippingBarContainer = $("[data-free-shipping-container]");
  if (countryAvailable && shippingBarContainer.length > 0) {
    if (cart.item_count == 0) {
      shippingBarContainer.addClass("hidden");
      return false;
    }
    let cartPrice = cart.original_total_price;
    let shippending = Shopify.formatMoney(
      convertShippingAmount - cartPrice,
      moneyFormat
    );
    let shippingPercentage = parseFloat(
      (cartPrice * 100) / convertShippingAmount
    ).toFixed(2);
    if (shippingPercentage > 10 && shippingPercentage < 100) {
      shippingPercentage = shippingPercentage - 5;
    } else if (shippingPercentage > 100) {
      shippingPercentage = 100;
    }
    if ($("[data-free-shipping-text]").length > 0) {
      if (shippingPercentage >= 100) {
        $("[data-free-shipping-text]").text(freeShippingBarSuccessText);
      } else {
        $("[data-free-shipping-text]").text(
          freeShippingBarText.replace("||amount||", shippending)
        );
      }
    }

    if ($("[data-free-shipping-bar]").length > 0) {
      $("[data-free-shipping-bar]").css("width", shippingPercentage + "%");
    }
    shippingBarContainer.removeClass("hidden");
  }
}

var favicon = false;

function browserTabNotification() {
  if (browserNotificationStatus) {
    favicon = new Favico({
      animation: "pop",
      bgColor: browserNotificationBg,
      textColor: browserNotificationText,
      type: browserNotificationShape,
    });
  }
}

$(document).ready(function () {
  browserTabNotification();
  if (favicon) {
    favicon.badge(cartItemsCount);
  }
  if (freeShippingBarStatus) {
    if (Shopify.currency.active != shopCurrency) {
      let shippingAmount = parseInt(freeShippingBarAmount);
      if (shippingAmount != undefined) {
        convertShippingAmount = parseFloat(
          (shippingAmount * Shopify.currency.rate).toFixed(2)
        );
      }
    }
  }
});

$(document).on("keydown", "[name=note]", function (e) {
  clearTimeout(cartNoteTyping);
});

$(document).on("keyup", "[name=note]", function (evt) {
  var _this = $(this);
  clearTimeout(cartNoteTyping);
  cartNoteTyping = setTimeout(function () {
    var currentVal = _this.val();
    var noteTicket = window.LumaryCartCoordinator.enqueue({
      source: "cart-note",
      showCart: false,
      skipRefresh: true,
      execute: function () {
        return new Promise(function (resolve, reject) {
          $.ajax({
            url: cartUpdateUrl,
            type: "POST",
            data: { note: currentVal },
            dataType: "json",
            timeout: cartRequestTimeout,
          })
            .done(resolve)
            .fail(function (XMLHttpRequest, textStatus, errorThrown) {
              reject({
                xhr: XMLHttpRequest,
                textStatus: textStatus,
                errorThrown: errorThrown,
              });
            });
        });
      },
    });
    noteTicket.mutation.then(
      function (cart) {
        window.LumaryCartCoordinator.recordServerCart(cart);
      },
      function () {}
    );
  }, 750);
});

/* ============================================================
 * GLM-FIX: Cart Refresh Shield (fetch + XHR read merge layer)
 * ------------------------------------------------------------
 * Problem: after each cart mutation, every cart-interested script
 * on the page (PageFly CRO inline, discount-on-cart-pro, Vitals,
 * pagefly-cart.js, ...) independently refetches GET /cart.js or
 * /cart.json. Measured on the live campaign page: 65 GET /cart.js
 * for 4 rapid adds, 14 of them rate-limited (429) — on mobile
 * networks Cloudflare escalates to a challenge, which surfaces as
 * "Your connection must be verified before the cart can refresh."
 *
 * Solution: transparently merge EVERY read of /cart.js|/cart.json
 * regardless of origin:
 *   1. In-flight dedup: concurrent identical reads share one
 *      network request (each caller still gets its own response).
 *   2. Micro-cache: a successful read is reusable for a short TTL
 *      (default 1500ms, configurable via window.LumaryCartQueueConfig.
 *      refreshCacheTtlMs, clamped to 250–5000).
 *   3. Write invalidation + epoch + poisoning:
 *      - any successful cart WRITE (add/change/update/clear, via
 *        fetch or XHR) drops the cache instantly;
 *      - every in-flight read is stamped with the write epoch at
 *        departure; a response that raced a write is delivered to
 *        its own caller only and NEVER cached (epoch guard);
 *      - reads that departed BEFORE a completed write are marked
 *        poisoned: later readers must NOT piggyback on them.
 *      Net guarantee: any read STARTED after a write completed
 *      always returns post-write data — discount apps recomputing
 *      after a cart change can never observe stale cart state.
 *   4. Failures pass through untouched (no caching of errors).
 * Writes themselves are never delayed or merged; the mutation
 * queue (minimumMutationInterval) is unchanged.
 * ============================================================ */
var LumaryCartRefreshShield = (function () {
  "use strict";

  var queueConfig = window.LumaryCartQueueConfig || {};
  var cacheTtlMs = Number(queueConfig.refreshCacheTtlMs);
  if (!Number.isFinite(cacheTtlMs)) {
    cacheTtlMs = 1500;
  }
  cacheTtlMs = Math.min(5000, Math.max(250, Math.floor(cacheTtlMs)));

  var READ_URL_RE = /\/cart\.(js|json)$/;
  var WRITE_URL_RE = /\/cart\/(add|change|update|clear)(\.js)?$/;

  var epoch = 0;                 // bumped on every successful write
  var cached = null;             // { at, epoch, bodyText, status, headers }
  var inflight = [];             // [{ url, departureEpoch, poisoned, resolveSettled }]

  var stats = {
    readsIntercepted: 0,
    dedupHits: 0,
    cacheHits: 0,
    networkReads: 0,
    writesObserved: 0,
    responsesRefusedCache: 0,
  };

  function normalizeUrl(rawUrl) {
    try {
      var url = new URL(String(rawUrl), window.location.origin);
      if (url.origin !== window.location.origin) {
        return null;
      }
      return { href: url.href, path: url.pathname };
    } catch (error) {
      return null;
    }
  }

  function isCartRead(rawUrl) {
    var parsed = normalizeUrl(rawUrl);
    return !!parsed && READ_URL_RE.test(parsed.path);
  }

  function isCartWriteMethod(method) {
    return String(method || "GET").toUpperCase() !== "GET";
  }

  function isCartWrite(rawUrl, method) {
    var parsed = normalizeUrl(rawUrl);
    return (
      !!parsed &&
      WRITE_URL_RE.test(parsed.path) &&
      isCartWriteMethod(method)
    );
  }

  function noteWriteStarted() {
    // A write is now in flight: reads departing before it completes
    // must be considered stale once it lands. Mark them poisoned so
    // no later reader piggybacks on them.
    for (var index = 0; index < inflight.length; index += 1) {
      inflight[index].poisoned = true;
    }
  }

  function noteWriteSucceeded() {
    epoch += 1;
    cached = null;
    stats.writesObserved += 1;
  }

  function findSharableInflight(path) {
    for (var index = 0; index < inflight.length; index += 1) {
      var entry = inflight[index];
      if (entry.path === path && !entry.poisoned) {
        return entry;
      }
    }
    return null;
  }

  function cacheMatches(path) {
    return (
      !!cached &&
      cached.path === path &&
      cached.epoch === epoch &&
      Date.now() - cached.at <= cacheTtlMs
    );
  }

  function cachedResponse() {
    return new Response(cached.bodyText, {
      status: cached.status,
      headers: cached.headers,
    });
  }

  function createInflightEntry(path) {
    var entry = {
      path: path,
      departureEpoch: epoch,
      poisoned: false,
      resolvers: [],
      settled: false,
      wait: function () {
        if (entry.settled) {
          return Promise.resolve();
        }
        return new Promise(function (resolve) {
          entry.resolvers.push(resolve);
        });
      },
    };
    inflight.push(entry);
    stats.networkReads += 1;
    return entry;
  }

  function settleInflight(entry, bodyText, source) {
    if (entry.settled) {
      return;
    }
    entry.settled = true;
    removeFromInflight(entry);
    var fresh = entry.departureEpoch === epoch && !entry.poisoned;
    var ok =
      source &&
      ((typeof source.ok === "boolean" && source.ok) ||
        (source.status >= 200 && source.status < 300));
    if (ok && fresh && bodyText) {
      cached = {
        at: Date.now(),
        epoch: epoch,
        path: entry.path,
        bodyText: bodyText,
        status: typeof source.status === "number" ? source.status : 200,
        headers:
          typeof source.getResponseHeader === "function"
            ? captureHeaders(source)
            : { "content-type": "application/json; charset=utf-8" },
      };
    } else if (!fresh) {
      stats.responsesRefusedCache += 1;
    }
    entry.resolvers.forEach(function (resolve) {
      resolve();
    });
    entry.resolvers = [];
  }

  function failInflight(entry) {
    if (entry.settled) {
      return;
    }
    entry.settled = true;
    removeFromInflight(entry);
    entry.resolvers.forEach(function (resolve) {
      resolve();
    });
    entry.resolvers = [];
  }

  function captureHeaders(xhr) {
    var headers = {};
    try {
      var contentType = xhr.getResponseHeader("content-type");
      if (contentType) {
        headers["content-type"] = contentType;
      }
    } catch (error) {}
    return headers;
  }

  /* ---------- fetch patch ---------- */
  var nativeFetch =
    typeof window.fetch === "function" ? window.fetch.bind(window) : null;

  function patchFetch() {
    if (!nativeFetch) {
      return;
    }
    window.fetch = function (input, init) {
      try {
        var url =
          typeof input === "string"
            ? input
            : input && typeof input.url === "string"
              ? input.url
              : "";
        var method = String(
          (init && init.method) ||
            (input && input.method) ||
            "GET"
        ).toUpperCase();

        if (isCartWrite(url, method)) {
          noteWriteStarted();
          return nativeFetch(input, init).then(
            function (response) {
              try {
                if (response && response.ok) {
                  noteWriteSucceeded();
                }
              } catch (error) {}
              return response;
            },
            function (error) {
              throw error;
            }
          );
        }

        if (isCartRead(url) && (!init || String(init.method || "GET").toUpperCase() === "GET")) {
          stats.readsIntercepted += 1;
          var parsed = normalizeUrl(url);
          var request = new Request(input, init || { method: "GET" });

          if (cacheMatches(parsed.path)) {
            stats.cacheHits += 1;
            return Promise.resolve(cachedResponse());
          }

          var sharable = findSharableInflight(parsed.path);
          if (sharable) {
            stats.dedupHits += 1;
            return sharable.wait().then(function () {
              if (cacheMatches(parsed.path)) {
                return cachedResponse();
              }
              // Leader's answer was refused (a write raced it) — the
              // follower must see post-write data, so fetch for real.
              return nativeFetch(request, { method: "GET" });
            });
          }

          var entry = createInflightEntry(parsed.path);
          return nativeFetch(request, { method: "GET" }).then(
            function (response) {
              try {
                response
                  .clone()
                  .text()
                  .then(function (bodyText) {
                    settleInflight(entry, bodyText, response);
                  })
                  .catch(function () {
                    failInflight(entry);
                  });
              } catch (error) {
                failInflight(entry);
              }
              return response;
            },
            function (error) {
              failInflight(entry);
              throw error;
            }
          );
        }
      } catch (hookError) {
        // Shield must never break a request; fall through to native.
      }
      return nativeFetch(input, init);
    };
  }

  /* ---------- XMLHttpRequest patch ---------- */
  var nativeOpen = XMLHttpRequest.prototype.open;
  var nativeSend = XMLHttpRequest.prototype.send;

  function patchXhr() {
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__lumaryShield = {
        method: String(method || "GET").toUpperCase(),
        url: String(url || ""),
        handled: false,
      };
      return nativeOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      var meta = this.__lumaryShield;
      if (!meta || meta.handled) {
        return nativeSend.apply(this, arguments);
      }
      try {
        if (isCartWrite(meta.url, meta.method)) {
          meta.handled = true;
          var xhr = this;
          noteWriteStarted();
          xhr.addEventListener("load", function () {
            try {
              if (xhr.status >= 200 && xhr.status < 300) {
                noteWriteSucceeded();
              }
            } catch (error) {}
          });
          return nativeSend.apply(this, arguments);
        }

        if (isCartRead(meta.url) && meta.method === "GET") {
          meta.handled = true;
          stats.readsIntercepted += 1;
          var parsed = normalizeUrl(meta.url);
          var xhrRequest = this;

          if (cacheMatches(parsed.path)) {
            stats.cacheHits += 1;
            deliverCachedToXhr(xhrRequest);
            return;
          }

          var sharable = findSharableInflight(parsed.path);
          if (sharable) {
            stats.dedupHits += 1;
            var sendArgs = arguments;
            sharable.wait().then(function () {
              if (cacheMatches(parsed.path)) {
                deliverCachedToXhr(xhrRequest);
              } else {
                nativeSend.apply(xhrRequest, sendArgs);
              }
            });
            return;
          }

          var entry = createInflightEntry(parsed.path);
          xhrRequest.addEventListener("load", function () {
            settleInflight(entry, xhrRequest.responseText, xhrRequest);
          });
          xhrRequest.addEventListener("error", function () {
            failInflight(entry);
          });
          xhrRequest.addEventListener("abort", function () {
            failInflight(entry);
          });
          return nativeSend.apply(this, arguments);
        }
      } catch (hookError) {
        // Never break the original request.
      }
      return nativeSend.apply(this, arguments);
    };
  }

  function deliverCachedToXhr(xhr) {
    // Serve a cache hit to an XHR caller WITHOUT any network request.
    // jQuery (and many libs) assign onreadystatechange/onload as PROPERTIES,
    // which dispatchEvent alone never triggers — so capture those callbacks
    // via setters and invoke them directly, in the browser's natural order.
    try {
      var handlers = {};
      var eventNames = [
        "onreadystatechange",
        "onload",
        "onloadend",
        "onprogress",
        "onabort",
        "onerror",
      ];
      eventNames.forEach(function (name) {
        try {
          Object.defineProperty(xhr, name, {
            set: function (fn) {
              handlers[name] = typeof fn === "function" ? fn : null;
            },
            get: function () {
              return handlers[name] || null;
            },
            configurable: true,
          });
        } catch (defineError) {}
      });

      var snapshot = cached;
      var props = {
        readyState: 4,
        status: snapshot.status,
        statusText: "OK",
        responseText: snapshot.bodyText,
        response: snapshot.bodyText,
        responseURL: xhr.__lumaryShield ? xhr.__lumaryShield.url : "",
      };
      Object.keys(props).forEach(function (key) {
        try {
          Object.defineProperty(xhr, key, {
            value: props[key],
            configurable: true,
          });
        } catch (defineError) {}
      });
      try {
        xhr.getAllResponseHeaders = function () {
          var headers = snapshot.headers || {};
          return Object.keys(headers)
            .map(function (name) {
              return name + ": " + headers[name];
            })
            .join("\r\n");
        };
        xhr.getResponseHeader = function (name) {
          var headers = snapshot.headers || {};
          return headers[String(name).toLowerCase()] || null;
        };
      } catch (defineError) {}

      window.setTimeout(function () {
        try {
          if (handlers.onreadystatechange) {
            handlers.onreadystatechange.call(xhr);
          }
          xhr.dispatchEvent(new Event("readystatechange"));
          if (handlers.onprogress) {
            handlers.onprogress.call(xhr);
          }
          if (handlers.onload) {
            handlers.onload.call(xhr);
          }
          xhr.dispatchEvent(new ProgressEvent("load"));
          if (handlers.onloadend) {
            handlers.onloadend.call(xhr);
          }
          xhr.dispatchEvent(new ProgressEvent("loadend"));
        } catch (callbackError) {}
      }, 0);
    } catch (error) {}
  }

  function removeFromInflight(entry) {
    var index = inflight.indexOf(entry);
    if (index > -1) {
      inflight.splice(index, 1);
    }
  }

  patchFetch();
  patchXhr();

  return {
    stats: stats,
    config: { cacheTtlMs: cacheTtlMs },
    peekCache: function () {
      return cached
        ? { age: Date.now() - cached.at, epoch: cached.epoch }
        : null;
    },
    invalidate: function () {
      cached = null;
    },
  };
})();

var cartDrawerLoadState = null;
var drawerRenderState = null;
var lastSuccessfulDrawerHtml = "";
var cartRequestTimeout = 15000;
var cartDrawerFailureType = "";
var cartDrawerSectionId = "cart-drawer-live";

function getCartDrawerSectionUrl() {
  var root = window.Shopify &&
    window.Shopify.routes &&
    window.Shopify.routes.root
    ? window.Shopify.routes.root
    : "/";
  var separator = root.indexOf("?") === -1 ? "?" : "&";
  return root + separator + "sections=" +
    encodeURIComponent(cartDrawerSectionId);
}

function getCartDrawerSectionResult(response) {
  var sectionHtml = response && response[cartDrawerSectionId];
  if (typeof sectionHtml !== "string" || !jQuery.trim(sectionHtml)) {
    return null;
  }
  var container = jQuery("<div>").html(sectionHtml);
  var cartSection = container.find("[data-cart-section]").first();
  var drawerBody = container.find("[data-drawer-body]").first();
  if (!drawerBody.length) {
    return null;
  }
  var itemCountValue = cartSection.attr("data-cart-item-count");
  var itemCount = Number(itemCountValue);
  return {
    html: drawerBody.html(),
    itemCount: itemCountValue !== "" &&
      typeof itemCountValue !== "undefined" &&
      Number.isFinite(itemCount)
      ? itemCount
      : null,
  };
}

function isCartDrawerHtml(html) {
  if (typeof html !== "string" || !jQuery.trim(html)) {
    return false;
  }
  var container = jQuery("<div>").html(html);
  return container.find(".cart-items-wrapper, .emptySideCart").length > 0;
}

function getReusableCartDrawerHtml(html) {
  if (typeof html !== "string" || !jQuery.trim(html)) {
    return "";
  }
  var container = jQuery("<div>").html(html);
  container.find("[data-cart-drawer-recovery]").remove();
  return container.html();
}

function canOpenCartDrawer(generation) {
  if (
    window.LumaryCartCoordinator &&
    typeof window.LumaryCartCoordinator.canOpenGeneration === "function"
  ) {
    return window.LumaryCartCoordinator.canOpenGeneration(generation);
  }
  return true;
}

function shouldPreserveActiveNonCartDrawer(showCart, generation) {
  var sharedDrawer = jQuery("[data-side-drawer]").first();
  return !!(
    sharedDrawer.length &&
    jQuery("body").hasClass("side_Drawer_open") &&
    !sharedDrawer.hasClass("mini_cart") &&
    !(showCart === true && canOpenCartDrawer(generation))
  );
}

function getCartSectionsUrl() {
  return window.location.pathname || "/";
}

function bundleSectionsIntoCartMutation(input, init) {
  try {
    var requestUrl = typeof input === "string"
      ? input
      : input && typeof input.url === "string"
        ? input.url
        : "";
    if (!requestUrl) {
      return { input: input, init: init };
    }
    var url = new URL(requestUrl, window.location.origin);
    var method = String(
      (init && init.method) || (input && input.method) || "GET"
    ).toUpperCase();
    var isCartMutation =
      url.origin === window.location.origin &&
      /^\/([a-z]{2}(-[a-z]{2})?\/)?cart\/(add|change|update|clear)\.js$/.test(
        url.pathname
      ) &&
      method === "POST";
    if (!isCartMutation) {
      return { input: input, init: init };
    }
    var body = init && init.body;
    var nextInit = jQuery.extend({}, init);
    if (typeof body === "string") {
      var trimmed = body.trim();
      if (trimmed.charAt(0) === "{") {
        var parsed = JSON.parse(trimmed);
        parsed.sections = cartDrawerSectionId;
        parsed.sections_url = getCartSectionsUrl();
        nextInit.body = JSON.stringify(parsed);
      } else {
        var stringParams = new URLSearchParams(trimmed);
        stringParams.set("sections", cartDrawerSectionId);
        stringParams.set("sections_url", getCartSectionsUrl());
        nextInit.body = stringParams.toString();
      }
      return { input: input, init: nextInit };
    }
    if (typeof URLSearchParams !== "undefined" && body instanceof URLSearchParams) {
      var params = new URLSearchParams(body);
      params.set("sections", cartDrawerSectionId);
      params.set("sections_url", getCartSectionsUrl());
      nextInit.body = params;
      return { input: input, init: nextInit };
    }
    if (typeof FormData !== "undefined" && body instanceof FormData) {
      var hasFile = false;
      body.forEach(function (value) {
        if (typeof value === "object" && value !== null) {
          hasFile = true;
        }
      });
      if (!hasFile) {
        var formData = new FormData();
        body.forEach(function (value, key) {
          formData.append(key, value);
        });
        formData.set("sections", cartDrawerSectionId);
        formData.set("sections_url", getCartSectionsUrl());
        nextInit.body = formData;
        return { input: input, init: nextInit };
      }
    }
  } catch (error) {}
  return { input: input, init: init };
}

function applyCartDrawerHtml(
  sectionResult,
  cart,
  showCart,
  element,
  generation
) {
  var html = sectionResult.html;
  var drawerBody = jQuery("[data-drawer-body]").first();
  if (shouldPreserveActiveNonCartDrawer(showCart, generation)) {
    lastSuccessfulDrawerHtml = getReusableCartDrawerHtml(html);
    if (sectionResult.itemCount !== null) {
      cartItemsCount = sectionResult.itemCount;
      emptyCartStatus = cartItemsCount === 0;
      jQuery("[data-cart-count]")
        .text(cartItemsCount > 0 && cartItemsCount < 100 ? cartItemsCount : "")
        .toggle(cartItemsCount > 0);
      if (favicon) {
        favicon.badge(cartItemsCount);
      }
    }
    return sectionResult;
  }
  var nextBody = jQuery("<div>").html(html);
  var currentLines = drawerBody
    .find("[data-cart-lines], .cart-items-wrapper")
    .first();
  var nextLines = nextBody
    .find("[data-cart-lines], .cart-items-wrapper")
    .first();
  var activeElement = document.activeElement;
  var activeLineKey = activeElement
    ? jQuery(activeElement).closest(".media-link").attr("data-id") || ""
    : "";
  var activeLineNumber = activeElement
    ? Number(jQuery(activeElement).closest(".media-link").attr("data-line")) || 0
    : 0;
  var activeSelector = activeElement && activeElement.classList
    ? activeElement.classList.contains("ajaxcart__qty-num")
      ? ".ajaxcart__qty-num"
      : activeElement.classList.contains("ajaxcart__qty--plus")
        ? ".ajaxcart__qty--plus"
      : activeElement.classList.contains("ajaxcart__qty--minus")
          ? ".ajaxcart__qty--minus"
          : activeElement.classList.contains("sd_mini_removeproduct")
            ? ".sd_mini_removeproduct"
          : ""
    : "";
  var scrollTop = drawerBody.scrollTop();
  drawerBody.find("[data-cart-drawer-recovery]").remove();
  cartDrawerFailureType = "";

  if (currentLines.length && nextLines.length) {
    currentLines.replaceWith(nextLines);
    var currentSummary = drawerBody.find("[data-cart-summary]").first();
    var nextSummary = nextBody.find("[data-cart-summary]").first();
    if (currentSummary.length && nextSummary.length) {
      var discountAppSummary = currentSummary
        .find(
          "#docapp-cart-with-coupon-summary, .docapp-cart-with-coupon-summary"
        )
        .first()
        .detach();
      if (discountAppSummary.length) {
        var nextSubtotal = nextSummary.find(".totle-price").first();
        if (nextSubtotal.length) {
          nextSubtotal.replaceWith(discountAppSummary);
        } else {
          nextSummary.append(discountAppSummary);
        }
      }
      currentSummary.replaceWith(nextSummary);
    }
    syncCartDrawerOptionalZone(
      drawerBody,
      nextBody,
      ".free_shipping",
      "[data-cart-lines], .cart-items-wrapper"
    );
    syncCartDrawerOptionalZone(
      drawerBody,
      nextBody,
      ".giftcard-box",
      ".cart-btn-container"
    );
  } else {
    drawerBody.html(html);
  }
  drawerBody.scrollTop(scrollTop);
  var focusWasRestored = false;
  if (activeLineKey && activeSelector) {
    var nextActiveElement = drawerBody
      .find(".media-link")
      .filter(function () {
        return String(jQuery(this).attr("data-id") || "") === activeLineKey;
      })
      .find(activeSelector)
      .first();
    if (nextActiveElement.length) {
      try {
        nextActiveElement[0].focus({ preventScroll: true });
      } catch (error) {
        nextActiveElement.trigger("focus");
      }
      focusWasRestored = true;
    }
  }
  if (activeLineKey && !focusWasRestored) {
    var fallbackLine = activeLineNumber
      ? drawerBody
          .find('.media-link[data-line="' + activeLineNumber + '"]')
          .first()
      : jQuery();
    if (!fallbackLine.length) {
      fallbackLine = drawerBody.find(".media-link").last();
    }
    var fallbackFocus = fallbackLine
      .find("button:enabled, a[href], input:enabled")
      .first();
    var focusTarget = fallbackFocus.length
      ? fallbackFocus
      : jQuery("[data-side-drawer]").first();
    if (focusTarget.length) {
      try {
        focusTarget[0].focus({ preventScroll: true });
      } catch (error) {
        focusTarget.trigger("focus");
      }
    }
  }
  if (sectionResult.itemCount !== null) {
    cartItemsCount = sectionResult.itemCount;
    emptyCartStatus = cartItemsCount === 0;
    jQuery("[data-cart-count]")
      .text(cartItemsCount > 0 && cartItemsCount < 100 ? cartItemsCount : "")
      .toggle(cartItemsCount > 0);
    if (favicon) {
      favicon.badge(cartItemsCount);
    }
  }
  syncCartClearHeaderAction();
  if (typeof renderCartLineNotices === "function") {
    renderCartLineNotices();
  }
  lastSuccessfulDrawerHtml = getReusableCartDrawerHtml(drawerBody.html());
  if (typeof updateCartSyncBanner === "function") {
    updateCartSyncBanner();
  }
  if (
    sectionResult.itemCount === null ||
    sectionResult.itemCount === Number(cart && cart.item_count)
  ) {
    freeShippingBar(cart);
    upsellCartDrawerProducts(cart, "drawer");
  }
  if (showCart) {
    activateCartDrawer(element, generation);
  }
  if (animationStatus && AOS) {
    AOS.refreshHard();
  }
  if (typeof syncCartControlsBusyState === "function") {
    syncCartControlsBusyState();
  }
  return sectionResult;
}

function syncCartDrawerOptionalZone(
  currentBody,
  nextBody,
  selector,
  beforeSelector
) {
  var currentZone = currentBody.find(selector).first();
  var nextZone = nextBody.find(selector).first();
  if (currentZone.length && nextZone.length) {
    currentZone.replaceWith(nextZone);
    return;
  }
  if (currentZone.length && !nextZone.length) {
    currentZone.remove();
    return;
  }
  if (!currentZone.length && nextZone.length) {
    var anchor = currentBody.find(beforeSelector).first();
    if (anchor.length) {
      nextZone.insertBefore(anchor);
    } else {
      currentBody.append(nextZone);
    }
  }
}


function syncCartClearHeaderAction() {
  var drawer = jQuery(".mini_cart");
  var title = drawer.find(".yv_side_drawer_title").first();
  var sourceButton = drawer.find("[data-drawer-body] [data-clear-cart]").first();
  title.find("[data-cart-clear-header]").remove();
  if (!title.length || !sourceButton.length) {
    return;
  }
  sourceButton.prop("hidden", true);
  sourceButton
    .clone(false)
    .prop("hidden", false)
    // GLM-FIX: the source button can be cloned while the cart controls
    // lock is held (drawer re-renders inside a quantity/clear cycle). The
    // clone would inherit disabled=true, have that recorded as its
    // "original" state, and never re-enable after unlock. Birth the header
    // clone enabled; syncCartControlsBusyState() re-applies the lock right
    // after this render if the cycle is still in flight.
    .prop("disabled", false)
    .removeAttr("disabled")
    .removeAttr("aria-disabled")
    .addClass("cart-clear-button--header")
    .attr("data-cart-clear-header", "")
    .insertBefore(title.find(".yv_side_drawer_close").first());
}

function createCartDrawerRecovery(message, failureType) {
  var recovery = jQuery("<div>", {
    "class": "cart-drawer-recovery",
    "data-cart-drawer-recovery": "",
    "data-cart-failure-type": failureType || "request",
  }).css({
    padding: "20px",
  });
  var errorId = "CartDrawerRecoveryError";
  recovery.append(
    jQuery("<p>", {
      id: errorId,
      "class": "cart-item-error error-text",
      role: "alert",
    }).css({
      margin: "0 0 12px",
    }).text(message || cartErrorLabel)
  );
  var actions = jQuery("<div>").css({
    display: "flex",
    "flex-wrap": "wrap",
    gap: "10px",
  });
  if (failureType !== "challenge") {
    var retryButton = jQuery("<button>", {
      type: "button",
      "data-cart-drawer-retry": "",
      "aria-describedby": errorId,
    }).css({
      "min-height": "44px",
      flex: "1 1 140px",
      padding: "10px 16px",
      border: "1px solid var(--colorBtnPrimaryBorder, currentColor)",
      color: "var(--colorBtnPrimaryText, inherit)",
      background: "var(--colorBtnPrimary, transparent)",
      cursor: "pointer",
      font: "inherit",
    }).text(cartRetryLabel);
    if (failureType === "rate-limit") {
      var retryAfter = Date.now() + getCartRetryDelay();
      retryButton
        .prop("disabled", true)
        .attr("data-cart-retry-after", retryAfter);
      updateCartRetryButton(retryButton, retryAfter);
    }
    actions.append(retryButton);
  }
  actions.append(
    jQuery("<a>", {
      href: mainCartUrl,
    }).css({
      "min-height": "44px",
      flex: "1 1 140px",
      display: "inline-flex",
      "align-items": "center",
      "justify-content": "center",
      padding: "10px 16px",
      border: "1px solid var(--colorBtnSecondaryBorder, currentColor)",
      color: "var(--colorBtnSecondaryText, inherit)",
      background: "var(--colorBtnSecondary, transparent)",
      "text-align": "center",
    }).text(failureType === "challenge" ? cartVerifyLabel : cartViewLabel)
  );
  actions.find("button, a")
    .on("focus", function () {
      jQuery(this).css({ outline: "2px solid currentColor", "outline-offset": "2px" });
    })
    .on("blur", function () {
      jQuery(this).css({ outline: "", "outline-offset": "" });
    });
  return recovery.append(actions);
}

function setCartDrawerShell(element, showCart, generation) {
  if (shouldPreserveActiveNonCartDrawer(showCart, generation)) {
    updateCartSyncBanner();
    return false;
  }
  var drawerBody = jQuery("[data-drawer-body]");
  var currentHtml = drawerBody.html();
  var reusableHtml = getReusableCartDrawerHtml(currentHtml);
  if (isCartDrawerHtml(reusableHtml)) {
    lastSuccessfulDrawerHtml = reusableHtml;
  } else if (isCartDrawerHtml(lastSuccessfulDrawerHtml)) {
    drawerBody.html(lastSuccessfulDrawerHtml);
  } else if (!drawerBody.find(".yv_load").length) {
    drawerBody.html(preLoadLoadGif);
  }
  jQuery("body").find("[data-drawer-title]").html(cartTitleLabel);
  jQuery("body")
    .find("[data-side-drawer]")
    .attr("class", "yv_side_drawer_wrapper")
    .attr("id", "mini__cart")
    .addClass("mini_cart");
  syncCartClearHeaderAction();
  var shouldOpen = showCart === true && canOpenCartDrawer(generation);
  if (shouldOpen && element && element.length) {
    focusElement = element;
  }
  if (shouldOpen) {
    jQuery("[data-side-drawer]")
      .attr("aria-hidden", "false")
      .removeAttr("inert");
    jQuery("body").addClass("side_Drawer_open");
  }
  updateCartSyncBanner();
  return true;
}

function activateCartDrawer(element, generation) {
  if (!canOpenCartDrawer(generation)) {
    return;
  }
  jQuery("[data-side-drawer]")
    .attr("aria-hidden", "false")
    .removeAttr("inert");
  jQuery("body").addClass("side_Drawer_open");
  jQuery("body").addClass("yv_side_Drawer_open");
  jQuery(".wrapper-overlay").css({ display: "block" });
  focusElementsRotation(jQuery("[data-side-drawer]"));
  if (element && element.length) {
    focusElement = element;
  }
  jQuery(document).find(".yv_side_drawer_wrapper").trigger("focus");
}

function restoreCartDrawerAfterFailure(
  showCart,
  element,
  previousHtml,
  message,
  failureType,
  generation
) {
  if (shouldPreserveActiveNonCartDrawer(showCart, generation)) {
    return;
  }
  if (showCart === true && !canOpenCartDrawer(generation)) {
    return;
  }
  var drawerBody = jQuery("[data-drawer-body]");
  var fallbackHtml = "";
  cartDrawerFailureType = failureType || "request";
  previousHtml = getReusableCartDrawerHtml(previousHtml);
  if (isCartDrawerHtml(lastSuccessfulDrawerHtml)) {
    fallbackHtml = lastSuccessfulDrawerHtml;
  } else if (isCartDrawerHtml(previousHtml)) {
    fallbackHtml = previousHtml;
  }
  if (fallbackHtml) {
    drawerBody.html(fallbackHtml);
  } else {
    drawerBody.empty();
  }
  drawerBody.prepend(
    createCartDrawerRecovery(message, cartDrawerFailureType)
  );
  syncCartClearHeaderAction();
  if (showCart) {
    activateCartDrawer(element, generation);
  }
}

function requestCartDrawer(showCart, element, reuseInFlight, generation) {
  setCartDrawerShell(element, showCart, generation);
  if (reuseInFlight && cartDrawerLoadState) {
    if (showCart === true) {
      cartDrawerLoadState.showCart = true;
      cartDrawerLoadState.element = element;
      cartDrawerLoadState.generation = generation;
      setCartDrawerShell(element, true, generation);
    }
    return cartDrawerLoadState.promise;
  }
  if (cartDrawerLoadState) {
    cartDrawerLoadState.abort();
  }

  var deferred = jQuery.Deferred();
  var state = {
    cartRequest: null,
    renderRequest: null,
    showCart: showCart === true,
    element: element,
    generation: generation,
    promise: deferred.promise(),
    abort: function () {
      if (state.cartRequest && state.cartRequest.readyState !== 4) {
        state.cartRequest.abort();
      }
      if (state.renderRequest && typeof state.renderRequest.abort === "function") {
        state.renderRequest.abort();
      }
    },
  };
  cartDrawerLoadState = state;
  state.cartRequest = jQuery.ajax({
    url: cartUrl,
    type: "GET",
    dataType: "json",
    timeout: cartRequestTimeout,
  });
  state.cartRequest
    .done(function (cart) {
      if (cartDrawerLoadState !== state) {
        deferred.reject(null, "abort");
        return;
      }
      state.renderRequest = buildCart(
        cart,
        state.showCart,
        state.element,
        state.generation
      );
      state.renderRequest
        .done(function (renderResult) {
          if (
            renderResult &&
            renderResult.itemCount !== null &&
            Number.isFinite(Number(renderResult.itemCount))
          ) {
            cart.drawer_item_count = Number(renderResult.itemCount);
          }
          deferred.resolve(cart);
        })
        .fail(function (XMLHttpRequest, textStatus) {
          deferred.reject(XMLHttpRequest, textStatus);
        });
    })
    .fail(function (XMLHttpRequest, textStatus) {
      if (textStatus !== "abort" && cartDrawerLoadState === state) {
        var failureType = classifyCartRequestFailure(
          XMLHttpRequest,
          textStatus
        );
        restoreCartDrawerAfterFailure(
          state.showCart,
          state.element,
          "",
          getCartFailureMessage(failureType, XMLHttpRequest),
          failureType,
          state.generation
        );
      }
      deferred.reject(XMLHttpRequest, textStatus);
    });
  deferred.always(function () {
    if (cartDrawerLoadState === state) {
      cartDrawerLoadState = null;
    }
  });
  return state.promise;
}

function getRequestErrorData(XMLHttpRequest) {
  var data = XMLHttpRequest && XMLHttpRequest.responseJSON;
  if (!data && XMLHttpRequest && XMLHttpRequest.responseText) {
    try {
      data = JSON.parse(XMLHttpRequest.responseText);
    } catch (error) {
      data = null;
    }
  }
  return data && typeof data === "object" ? data : {};
}

function getCartRetryDelay() {
  var delay = typeof cartRetryDelay !== "undefined"
    ? Number(cartRetryDelay)
    : 8000;
  return Number.isFinite(delay) && delay > 0 ? delay : 8000;
}

function getCartRetryInText(seconds) {
  var template = typeof cartRetryInLabel === "string"
    ? cartRetryInLabel
    : cartRetryLabel;
  return template.indexOf("[seconds]") > -1
    ? template.replace("[seconds]", String(seconds))
    : template;
}

function updateCartRetryButton(button, retryAfter) {
  function update() {
    var seconds = Math.max(0, Math.ceil((retryAfter - Date.now()) / 1000));
    if (seconds === 0) {
      button.prop("disabled", false).removeAttr("data-cart-retry-after");
      button.text(cartRetryLabel);
      return false;
    }
    button.text(getCartRetryInText(seconds));
    return true;
  }
  update();
  var timer = window.setInterval(function () {
    if (!document.documentElement.contains(button[0]) || !update()) {
      window.clearInterval(timer);
    }
  }, 1000);
}

function getCartResponseHeader(response, name) {
  if (!response) {
    return "";
  }
  try {
    if (response.headers && typeof response.headers.get === "function") {
      return String(response.headers.get(name) || "");
    }
    if (typeof response.getResponseHeader === "function") {
      return String(response.getResponseHeader(name) || "");
    }
  } catch (error) {}
  return "";
}

function isCartChallengeResponse(response) {
  var mitigated = getCartResponseHeader(response, "cf-mitigated").toLowerCase();
  if (mitigated === "challenge") {
    return true;
  }
  var contentType = getCartResponseHeader(response, "content-type").toLowerCase();
  var responseText = String(
    response && (response.responseText || response.cartResponseText || "")
  ).toLowerCase();
  if (
    responseText.indexOf("cdn-cgi/challenge-platform") > -1 ||
    responseText.indexOf("verifying your connection") > -1 ||
    responseText.indexOf("cf-chl-") > -1
  ) {
    return true;
  }
  return contentType.indexOf("text/html") > -1 &&
    (Number(response.status) >= 400 || typeof response.ok === "boolean");
}

function classifyFetchCartResponse(response) {
  if (isCartChallengeResponse(response)) {
    return "challenge";
  }
  if (response && Number(response.status) === 429) {
    return "rate-limit";
  }
  if (!response || response.ok !== true) {
    return "request";
  }
  return "";
}

function classifyCartRequestFailure(response, textStatus) {
  if (response && response.failureType) {
    return response.failureType;
  }
  if (textStatus === "timeout" || (response && response.textStatus === "timeout")) {
    return "timeout";
  }
  var target = response && response.xhr ? response.xhr : response;
  if (
    target &&
    (target instanceof TypeError || target.name === "TypeError") &&
    typeof target.status === "undefined"
  ) {
    return "network";
  }
  if (isCartChallengeResponse(target)) {
    return "challenge";
  }
  if (target && Number(target.status) === 429) {
    return "rate-limit";
  }
  if (target && Number(target.status) === 0) {
    return "network";
  }
  return "request";
}

function getCartFailureMessage(failureType, response) {
  if (response && response.cartMessage) {
    return response.cartMessage;
  }
  if (failureType === "challenge") {
    return typeof cartVerificationRequired === "string"
      ? cartVerificationRequired
      : cartErrorLabel;
  }
  if (failureType === "rate-limit") {
    return cartRateLimitError;
  }
  var target = response && response.xhr ? response.xhr : response;
  return getRequestErrorMessage(target);
}

function collectRequestErrorMessages(value, messages, seen, depth) {
  if (depth > 5 || value === null || typeof value === "undefined") {
    return;
  }
  if (typeof value === "string") {
    var message = jQuery.trim(value);
    if (message && message !== "[object Object]") {
      messages.push(message);
    }
    return;
  }
  if (typeof value !== "object" || seen.indexOf(value) > -1) {
    return;
  }
  seen.push(value);
  if (Array.isArray(value)) {
    jQuery.each(value, function (_index, item) {
      collectRequestErrorMessages(item, messages, seen, depth + 1);
    });
    return;
  }
  var preferredKeys = ["description", "message", "detail", "error"];
  jQuery.each(preferredKeys, function (_index, key) {
    if (Object.prototype.hasOwnProperty.call(value, key)) {
      collectRequestErrorMessages(value[key], messages, seen, depth + 1);
    }
  });
  jQuery.each(value, function (key, item) {
    if (preferredKeys.indexOf(key) === -1) {
      collectRequestErrorMessages(item, messages, seen, depth + 1);
    }
  });
}

function getRequestErrorsMessage(errors) {
  var messages = [];
  collectRequestErrorMessages(errors, messages, [], 0);
  return messages.filter(function (message, index) {
    return messages.indexOf(message) === index;
  }).join(", ");
}

function getRequestErrorMessage(XMLHttpRequest) {
  if (XMLHttpRequest && XMLHttpRequest.cartMessage) {
    return XMLHttpRequest.cartMessage;
  }
  var data = getRequestErrorData(XMLHttpRequest);
  var descriptionMessage = getRequestErrorsMessage(data.description);
  if (descriptionMessage) {
    return descriptionMessage;
  }
  var errorsMessage = getRequestErrorsMessage(data.errors);
  if (errorsMessage) {
    return errorsMessage;
  }
  var message = getRequestErrorsMessage(data.message);
  if (message) {
    return message;
  }
  if (XMLHttpRequest && Number(XMLHttpRequest.status) === 429) {
    return cartRateLimitError;
  }
  return cartErrorLabel;
}

function createCartMutationCoordinator() {
  var nativeFetch = typeof window.fetch === "function"
    ? window.fetch.bind(window)
    : null;
  var queue = [];
  var active = false;
  var queueStartTimer = null;
  var lastMutationStartedAt = 0;
  var cartQueueConfig = window.LumaryCartQueueConfig || {};
  var coarsePointer = false;
  try {
    coarsePointer = !!(
      window.matchMedia && window.matchMedia("(pointer: coarse)").matches
    );
  } catch (error) {}
  var minimumMutationInterval = Number(
    cartQueueConfig.minimumMutationInterval
  );
  if (!Number.isFinite(minimumMutationInterval)) {
    minimumMutationInterval = coarsePointer ? 1000 : 750;
  }
  minimumMutationInterval = Math.min(
    5000,
    Math.max(400, Math.floor(minimumMutationInterval))
  );
  var cartReconcileDelay = Number(cartQueueConfig.reconcileDelay);
  if (!Number.isFinite(cartReconcileDelay)) {
    cartReconcileDelay = coarsePointer ? 900 : 700;
  }
  cartReconcileDelay = Math.min(
    5000,
    Math.max(400, Math.floor(cartReconcileDelay))
  );
  var refreshTimer = null;
  var refreshInFlight = false;
  var refreshVersion = 0;
  var refreshWaiters = [];
  var refreshRequested = false;
  var refreshOpenGeneration = 0;
  var refreshTrigger = null;
  var refreshHolds = {};
  var blockedState = null;
  var blockedTimer = null;
  var expectedItemCount = null;
  var lastObservedItemCount = Number(cartItemsCount) || 0;
  var latestIssuedGeneration = 0;
  var dismissedThroughGeneration = 0;
  var currentBatchBaseline = lastObservedItemCount;
  var activeExpectedDelta = 0;
  var sectionsBundle = null;
  var mutationRevision = 0;
  var diagnostics = {
    queued: 0,
    completed: 0,
    failed: 0,
    refreshes: 0,
    blocked: 0,
    catchUpAttempts: 0,
    catchUpCompleted: 0,
    catchUpExhausted: 0,
    throttledStarts: 0,
    sources: {},
  };

  function getRequestSlotDelay() {
    if (!lastMutationStartedAt) {
      return 0;
    }
    return Math.max(
      0,
      minimumMutationInterval - (Date.now() - lastMutationStartedAt)
    );
  }

  function waitForRequestSlot() {
    var delay = getRequestSlotDelay();
    if (!delay) {
      lastMutationStartedAt = Date.now();
      return Promise.resolve();
    }
    diagnostics.throttledStarts += 1;
    syncStateChange();
    return new Promise(function (resolve) {
      window.setTimeout(function () {
        lastMutationStartedAt = Date.now();
        resolve();
      }, delay);
    });
  }

  function normalizePositiveQuantity(value) {
    var quantity = Number(value);
    return Number.isFinite(quantity) && quantity > 0
      ? Math.floor(quantity)
      : 0;
  }

  function issueVisibilityGeneration() {
    latestIssuedGeneration += 1;
    return latestIssuedGeneration;
  }

  function normalizeVisibilityGeneration(value) {
    var generation = Number(value);
    return Number.isInteger(generation) && generation > 0
      ? generation
      : latestIssuedGeneration;
  }

  function canOpenGeneration(value) {
    var generation = normalizeVisibilityGeneration(value);
    return generation > dismissedThroughGeneration;
  }

  function getObjectItemCountDelta(data) {
    if (!data || typeof data !== "object") {
      return 0;
    }
    if (Array.isArray(data.items)) {
      return data.items.reduce(function (total, item) {
        return total + (normalizePositiveQuantity(item && item.quantity) || 1);
      }, 0);
    }
    return normalizePositiveQuantity(data.quantity) || (data.id ? 1 : 0);
  }

  function getCartAddItemCountDelta(input, init) {
    var requestUrl = typeof input === "string"
      ? input
      : input && typeof input.url === "string"
        ? input.url
        : "";
    try {
      var url = new URL(requestUrl, window.location.origin);
      if (!/\/cart\/add\.js$/.test(url.pathname)) {
        return 0;
      }
    } catch (error) {
      return 0;
    }
    var body = init && init.body;
    if (typeof FormData !== "undefined" && body instanceof FormData) {
      var formDataTotal = 0;
      body.forEach(function (value, key) {
        if (key === "quantity" || /\[quantity\]$/.test(key)) {
          formDataTotal += normalizePositiveQuantity(value) || 1;
        }
      });
      return formDataTotal || 1;
    }
    if (
      typeof URLSearchParams !== "undefined" &&
      body instanceof URLSearchParams
    ) {
      var searchQuantity = normalizePositiveQuantity(body.get("quantity"));
      return searchQuantity || 1;
    }
    if (typeof body === "string") {
      try {
        var jsonDelta = getObjectItemCountDelta(JSON.parse(body));
        if (jsonDelta) {
          return jsonDelta;
        }
      } catch (error) {
        try {
          var params = new URLSearchParams(body);
          return normalizePositiveQuantity(params.get("quantity")) || 1;
        } catch (paramsError) {
          return 1;
        }
      }
    }
    return 1;
  }

  function registerExpectedItemCount(delta) {
    delta = normalizePositiveQuantity(delta);
    if (!delta) {
      return;
    }
    if (expectedItemCount === null) {
      expectedItemCount = Math.max(
        lastObservedItemCount,
        Number(cartItemsCount) || 0
      );
    }
    expectedItemCount += delta;
  }

  function getCartSnapshotItemCount(cart) {
    var drawerValue = cart && cart.drawer_item_count;
    var drawerItemCount = Number(drawerValue);
    if (
      drawerValue !== null &&
      typeof drawerValue !== "undefined" &&
      drawerValue !== "" &&
      Number.isFinite(drawerItemCount)
    ) {
      return drawerItemCount;
    }
    var itemValue = cart && cart.item_count;
    var itemCount = Number(itemValue);
    return itemValue !== null &&
      typeof itemValue !== "undefined" &&
      itemValue !== "" &&
      Number.isFinite(itemCount)
      ? itemCount
      : null;
  }

  function recordCartSnapshot(cart) {
    var itemCount = getCartSnapshotItemCount(cart);
    if (itemCount !== null) {
      lastObservedItemCount = itemCount;
    }
    return itemCount;
  }

  function recordServerItemCount(value) {
    var itemCount = Number(value);
    if (!Number.isFinite(itemCount) || itemCount < 0) {
      return null;
    }
    lastObservedItemCount = itemCount;
    return itemCount;
  }

  function acceptAuthoritativeCart(cart) {
    var itemCount = recordCartSnapshot(cart);
    expectedItemCount = null;
    refreshRequested = false;
    refreshOpenGeneration = 0;
    refreshTrigger = null;
    sectionsBundle = null;
    refreshVersion += 1;
    window.clearTimeout(refreshTimer);
    resolveRefreshWaiters(cart);
    syncStateChange();
    return itemCount;
  }

  function createError(failureType, message, details) {
    var error = new Error(message || cartErrorLabel);
    error.failureType = failureType || "request";
    error.cartMessage = message || cartErrorLabel;
    if (details && details.xhr) {
      error.xhr = details.xhr;
    }
    if (details && details.response) {
      error.response = details.response;
    }
    if (details && details.textStatus) {
      error.textStatus = details.textStatus;
    }
    return error;
  }

  function isBlockingFailure(failureType) {
    return ["challenge", "rate-limit", "network", "timeout"].indexOf(
      failureType
    ) > -1;
  }

  function getBlock() {
    if (
      blockedState &&
      blockedState.until !== Infinity &&
      Date.now() >= blockedState.until
    ) {
      blockedState = null;
      window.clearTimeout(blockedTimer);
      blockedTimer = null;
    }
    return blockedState;
  }

  function rejectQueued(error) {
    while (queue.length) {
      var queuedItem = queue.shift();
      queuedItem.rejectMutation(error);
      queuedItem.resolveRefresh(null);
    }
  }

  function setBlocked(failureType, message) {
    var duration = failureType === "challenge"
      ? Infinity
      : failureType === "rate-limit"
        ? getCartRetryDelay()
        : 3000;
    blockedState = {
      type: failureType,
      message: message || getCartFailureMessage(failureType),
      until: duration === Infinity ? Infinity : Date.now() + duration,
    };
    window.clearTimeout(blockedTimer);
    blockedTimer = null;
    if (duration !== Infinity) {
      blockedTimer = window.setTimeout(function () {
        if (
          blockedState &&
          blockedState.until !== Infinity &&
          Date.now() >= blockedState.until
        ) {
          blockedState = null;
          blockedTimer = null;
          syncStateChange();
        }
      }, duration + 20);
    }
    diagnostics.blocked += 1;
    expectedItemCount = null;
    refreshRequested = false;
    refreshOpenGeneration = 0;
    refreshTrigger = null;
    sectionsBundle = null;
    window.clearTimeout(queueStartTimer);
    queueStartTimer = null;
    resolveRefreshWaiters(null);
    rejectQueued(
      createError(blockedState.type, blockedState.message)
    );
    syncStateChange();
  }

  function hasRefreshHolds() {
    return Object.keys(refreshHolds).some(function (key) {
      return refreshHolds[key] > 0;
    });
  }

  function getEnqueuedPendingDelta() {
    var total = activeExpectedDelta;
    for (var index = 0; index < queue.length; index += 1) {
      total += queue[index].expectedItemCountDelta || 0;
    }
    return total;
  }

  function getPageflyPendingCount() {
    try {
      var bridge = window.LumaryPageFlyCartBridge;
      var bridgeStats = bridge && typeof bridge.getStats === "function"
        ? bridge.getStats()
        : null;
      return Number(bridgeStats && bridgeStats.pending) || 0;
    } catch (error) {
      return 0;
    }
  }

  function getSyncStatusInternal() {
    var coordinatorPending = queue.length + (active ? 1 : 0);
    var pageflyPending = getPageflyPendingCount();
    var pending = Math.max(coordinatorPending, pageflyPending);
    var confirmed = lastObservedItemCount;
    var total = confirmed;
    var optimistic = lastObservedItemCount + getEnqueuedPendingDelta();
    var bridge = window.LumaryPageFlyCartBridge;
    var bridgeStats = bridge && typeof bridge.getStats === "function"
      ? bridge.getStats()
      : null;
    if (optimistic > total) {
      total = optimistic;
    }
    if (expectedItemCount !== null && expectedItemCount > total) {
      total = expectedItemCount;
    }
    var pageflyBatchActive = Number(bridgeStats && bridgeStats.generation) > 0;
    var progressTotal = pageflyBatchActive
      ? Number(bridgeStats && bridgeStats.batchTotal) || 0
      : 0;
    var progressFailed = pageflyBatchActive
      ? Number(bridgeStats && bridgeStats.batchFailed) || 0
      : 0;
    var syncing = pending > 0 ||
      refreshRequested ||
      refreshInFlight ||
      hasRefreshHolds();
    if (syncing && progressTotal > 0) {
      total = Math.max(
        total,
        currentBatchBaseline + Math.max(progressTotal - progressFailed, 0)
      );
    }
    return {
      pending: pending,
      syncing: syncing,
      blocked: !!getBlock(),
      confirmed: confirmed,
      total: total,
      progressConfirmed: pageflyBatchActive
        ? Number(bridgeStats && bridgeStats.batchConfirmed) || 0
        : 0,
      progressFailed: progressFailed,
      progressTotal: progressTotal,
    };
  }

  function syncStateChange() {
    try {
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:pending-changed", {
          detail: getSyncStatusInternal(),
        })
      );
    } catch (error) {}
  }

function storeSectionsBundle(data, revision) {
    if (data && typeof data === "object") {
      if (!sectionsBundle || revision >= sectionsBundle.revision) {
        // Keep the newest parsed mutation response even when Shopify returns a
        // null/missing section. That invalidates any older, now-stale section
        // and deliberately forces one authoritative GET fallback.
        sectionsBundle = { data: data, revision: revision };
      }
    }
  }

  function takeSectionsBundle() {
    var bundle = sectionsBundle;
    sectionsBundle = null;
    return bundle;
  }

  function toJQueryTrigger(trigger) {
    if (!trigger) {
      return null;
    }
    return trigger.jquery ? trigger : jQuery(trigger);
  }

  function jqueryPromiseToNative(request) {
    return new Promise(function (resolve, reject) {
      request
        .done(function (value) {
          resolve(value);
        })
        .fail(function (XMLHttpRequest, textStatus, errorThrown) {
          reject({
            xhr: XMLHttpRequest,
            textStatus: textStatus,
            errorThrown: errorThrown,
            cartDrawerHandled: textStatus !== "abort",
          });
        });
    });
  }

  function updateCartCountFromResponse(cart) {
    if (!cart || typeof cart.item_count === "undefined") {
      return;
    }
    jQuery("[data-cart-count]")
      .text(cart.item_count > 0 && cart.item_count < 100 ? cart.item_count : "")
      .toggle(cart.item_count > 0);
  }

  function performCartRefresh(showCart, trigger, generation) {
    if (
      typeof cartDrawerEnable !== "undefined" &&
      cartDrawerEnable &&
      typeof requestCartDrawer === "function"
    ) {
      var bundle = takeSectionsBundle();
      if (bundle) {
        var sectionResult = null;
        try {
          sectionResult = getCartDrawerSectionResult(bundle.data.sections);
        } catch (parseError) {
          sectionResult = null;
        }
        if (
          sectionResult &&
          sectionResult.itemCount !== null &&
          isCartDrawerHtml(sectionResult.html)
        ) {
          try {
            setCartDrawerShell(
              toJQueryTrigger(trigger),
              showCart,
              generation
            );
            if (cartDrawerLoadState) {
              cartDrawerLoadState.abort();
              cartDrawerLoadState = null;
            }
            if (drawerRenderState) {
              drawerRenderState.abort();
              drawerRenderState = null;
            }
            recordServerItemCount(sectionResult.itemCount);
            expectedItemCount = null;
            bundle.data.drawer_item_count = sectionResult.itemCount;
            updateCartCountFromResponse(bundle.data);
            applyCartDrawerHtml(
              sectionResult,
              bundle.data,
              showCart,
              toJQueryTrigger(trigger),
              generation
            );
            return Promise.resolve(bundle.data);
          } catch (renderError) {
            /* Fall through to a network refresh below. */
          }
        }
      }
      return waitForRequestSlot().then(function () {
        return jqueryPromiseToNative(
          requestCartDrawer(
            showCart,
            toJQueryTrigger(trigger),
            false,
            generation
          )
        );
      });
    }
    if (!nativeFetch) {
      return Promise.resolve(null);
    }
    return waitForRequestSlot().then(function () {
      return nativeFetch(cartUrl, {
        credentials: "same-origin",
        headers: { Accept: "application/json" },
      });
    }).then(function (response) {
      var failureType = classifyFetchCartResponse(response);
      if (failureType) {
        throw createError(
          failureType,
          getCartFailureMessage(failureType, response),
          { response: response }
        );
      }
      return response.json();
    }).then(function (cart) {
      updateCartCountFromResponse(cart);
      return cart;
    });
  }

  function performProgressiveCartRefresh(
    version,
    showCart,
    trigger,
    generation
  ) {
    diagnostics.refreshes += 1;
    return performCartRefresh(showCart, trigger, generation).then(function (cart) {
      var itemCount = recordCartSnapshot(cart);
      if (version !== refreshVersion || queue.length || active) {
        return { cart: cart, stale: true };
      }
      if (expectedItemCount !== null) {
        if (itemCount !== null && itemCount >= expectedItemCount) {
          diagnostics.catchUpCompleted += 1;
        } else {
          diagnostics.catchUpExhausted += 1;
        }
      }
      expectedItemCount = null;
      return { cart: cart, stale: false };
    }).catch(function (error) {
      expectedItemCount = null;
      throw error;
    });
  }

  function resolveRefreshWaiters(cart) {
    var waiters = refreshWaiters.slice();
    refreshWaiters = [];
    waiters.forEach(function (resolve) {
      resolve(cart || null);
    });
  }

  function scheduleRefresh() {
    window.clearTimeout(refreshTimer);
    if (
      !refreshRequested ||
      active ||
      queue.length ||
      refreshInFlight ||
      hasRefreshHolds()
    ) {
      return;
    }
    refreshTimer = window.setTimeout(function () {
      if (
        active ||
        queue.length ||
        refreshInFlight ||
        hasRefreshHolds()
      ) {
        scheduleRefresh();
        return;
      }
      var version = refreshVersion;
      var generation = refreshOpenGeneration;
      var showCart = generation > 0;
      var trigger = refreshTrigger;
      refreshInFlight = true;
      performProgressiveCartRefresh(version, showCart, trigger, generation)
        .then(function (result) {
          var cart = result.cart;
          if (
            result.stale ||
            version !== refreshVersion ||
            queue.length ||
            active
          ) {
            refreshInFlight = false;
            processQueue();
            scheduleRefresh();
            return;
          }
          refreshRequested = false;
          refreshOpenGeneration = 0;
          refreshTrigger = null;
          expectedItemCount = null;
          refreshInFlight = false;
          resolveRefreshWaiters(cart);
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:updated", {
              detail: { cart: cart, source: "lumary-cart-coordinator" },
            })
          );
          syncStateChange();
          processQueue();
        })
        .catch(function (error) {
          if (error && error.textStatus === "abort") {
            refreshInFlight = false;
            processQueue();
            scheduleRefresh();
            return;
          }
          var failureType = classifyCartRequestFailure(
            error,
            error && error.textStatus
          );
          var message = getCartFailureMessage(failureType, error);
          refreshRequested = false;
          refreshOpenGeneration = 0;
          refreshTrigger = null;
          expectedItemCount = null;
          refreshInFlight = false;
          resolveRefreshWaiters(null);
          if (isBlockingFailure(failureType)) {
            setBlocked(failureType, message);
          }
          if (!error || !error.cartDrawerHandled) {
            showFailure(failureType, message, trigger, generation);
          }
          syncStateChange();
          processQueue();
        });
    }, cartReconcileDelay);
  }

  function completeItem(item) {
    active = false;
    activeExpectedDelta = 0;
    diagnostics.completed += 1;
    syncStateChange();
    processQueue();
    scheduleRefresh();
  }

  function failItem(item, error) {
    var failureType = classifyCartRequestFailure(
      error,
      error && error.textStatus
    );
    var message = getCartFailureMessage(failureType, error);
    var normalizedError = error instanceof Error
      ? error
      : createError(failureType, message, error);
    normalizedError.failureType = failureType;
    normalizedError.cartMessage = message;
    item.rejectMutation(normalizedError);
    item.resolveRefresh(null);
    diagnostics.failed += 1;
    if (isBlockingFailure(failureType)) {
      setBlocked(failureType, message);
      if (
        item.showCart ||
        (jQuery("body").hasClass("side_Drawer_open") &&
          jQuery("[data-side-drawer]").first().hasClass("mini_cart"))
      ) {
        showFailure(
          failureType,
          message,
          item.trigger,
          item.visibilityGeneration
        );
      }
    }
    completeItem(item);
  }

  function processQueue() {
    if (active || refreshInFlight || queue.length === 0) {
      scheduleRefresh();
      return;
    }
    var slotDelay = getRequestSlotDelay();
    if (slotDelay > 0) {
      if (!queueStartTimer) {
        diagnostics.throttledStarts += 1;
        queueStartTimer = window.setTimeout(function () {
          queueStartTimer = null;
          processQueue();
        }, slotDelay);
      }
      syncStateChange();
      return;
    }
    window.clearTimeout(queueStartTimer);
    queueStartTimer = null;
    var item = queue.shift();
    active = true;
    lastMutationStartedAt = Date.now();
    activeExpectedDelta = item.expectedItemCountDelta || 0;
    if (!item.managesSectionsBundle) {
      // A mutation without a parsed bundled-section response makes every
      // previously cached section snapshot stale.
      sectionsBundle = null;
    }
    Promise.resolve()
      .then(item.execute)
      .then(function (result) {
        var failureType = item.getFailureType
          ? item.getFailureType(result)
          : "";
        if (failureType) {
          var message = getCartFailureMessage(failureType, result);
          var failure = createError(failureType, message, { response: result });
          if (item.resolveFailureResult) {
            item.resolveMutation(result);
          } else {
            item.rejectMutation(failure);
          }
          item.resolveRefresh(null);
          diagnostics.failed += 1;
          if (isBlockingFailure(failureType)) {
            setBlocked(failureType, message);
            if (
              item.showCart ||
              (jQuery("body").hasClass("side_Drawer_open") &&
                jQuery("[data-side-drawer]").first().hasClass("mini_cart"))
            ) {
              showFailure(
                failureType,
                message,
                item.trigger,
                item.visibilityGeneration
              );
            }
          } else if (!item.skipRefresh) {
            refreshRequested = true;
            refreshVersion += 1;
            if (
              item.showCart &&
              item.visibilityGeneration > refreshOpenGeneration
            ) {
              refreshOpenGeneration = item.visibilityGeneration;
            }
            if (item.trigger) {
              refreshTrigger = item.trigger;
            }
          }
          completeItem(item);
          return;
        }
        item.resolveMutation(result);
        if (item.skipRefresh) {
          item.resolveRefresh(result);
          completeItem(item);
          return;
        }
        registerExpectedItemCount(item.expectedItemCountDelta);
        refreshWaiters.push(item.resolveRefresh);
        refreshRequested = true;
        refreshVersion += 1;
        if (
          item.showCart &&
          item.visibilityGeneration > refreshOpenGeneration
        ) {
          refreshOpenGeneration = item.visibilityGeneration;
        }
        if (item.trigger) {
          refreshTrigger = item.trigger;
        }
        completeItem(item);
      })
      .catch(function (error) {
        failItem(item, error);
      });
  }

  function enqueue(options) {
    options = options || {};
    var mutationResolve;
    var mutationReject;
    var refreshResolve;
    var mutation = new Promise(function (resolve, reject) {
      mutationResolve = resolve;
      mutationReject = reject;
    });
    var refreshed = new Promise(function (resolve) {
      refreshResolve = resolve;
    });
    var source = options.source || "unknown";
    var suppliedGeneration = Number(options.visibilityGeneration);
    var hasSuppliedGeneration = Number.isInteger(suppliedGeneration) &&
      suppliedGeneration > 0;
    var visibilityGeneration = hasSuppliedGeneration
      ? suppliedGeneration
      : normalizeVisibilityGeneration(options.visibilityGeneration);
    if (options.showCart === true && !hasSuppliedGeneration) {
      visibilityGeneration = issueVisibilityGeneration();
      currentBatchBaseline = lastObservedItemCount;
    }
    diagnostics.queued += 1;
    diagnostics.sources[source] = (diagnostics.sources[source] || 0) + 1;
    var block = getBlock();
    if (block) {
      mutationReject(createError(block.type, block.message));
      refreshResolve(null);
      if (options.showCart === true) {
        showFailure(
          block.type,
          block.message,
          options.trigger,
          visibilityGeneration
        );
      }
      syncStateChange();
      return {
        mutation: mutation,
        refreshed: refreshed,
        visibilityGeneration: visibilityGeneration,
      };
    }
    // A cart mutation supersedes any older drawer GET/render. Aborting it here
    // prevents a partial pre-mutation snapshot from flashing over the queue.
    if (cartDrawerLoadState) {
      cartDrawerLoadState.abort();
      cartDrawerLoadState = null;
    }
    if (drawerRenderState) {
      drawerRenderState.abort();
      drawerRenderState = null;
    }
    queue.push({
      execute: options.execute,
      getFailureType: options.getFailureType,
      resolveFailureResult: options.resolveFailureResult === true,
      showCart: options.showCart === true,
      trigger: options.trigger || null,
      resolveMutation: mutationResolve,
      rejectMutation: mutationReject,
      resolveRefresh: refreshResolve,
      expectedItemCountDelta: options.expectedItemCountDelta || 0,
      visibilityGeneration: visibilityGeneration,
      skipRefresh: options.skipRefresh === true,
      managesSectionsBundle: options.managesSectionsBundle === true,
    });
    window.clearTimeout(refreshTimer);
    processQueue();
    syncStateChange();
    return {
      mutation: mutation,
      refreshed: refreshed,
      visibilityGeneration: visibilityGeneration,
    };
  }

  function enqueueFetch(input, init, options) {
    options = options || {};
    if (!nativeFetch) {
      return enqueue({
        source: options.source,
        execute: function () {
          throw createError("network", cartErrorLabel);
        },
        showCart: options.showCart,
        trigger: options.trigger,
      });
    }
    var prepared = options.bundleSections === false
      ? { input: input, init: init }
      : bundleSectionsIntoCartMutation(input, init);
    var requestRevision = mutationRevision + 1;
    mutationRevision = requestRevision;

    function fetchWithTimeout(requestInput, requestInit, consumeResponse) {
      if (typeof AbortController === "undefined") {
        return nativeFetch(requestInput, requestInit).then(function (response) {
          return typeof consumeResponse === "function"
            ? consumeResponse(response, function () { return false; })
            : response;
        });
      }
      var controller = new AbortController();
      var nextInit = Object.assign({}, requestInit || {}, {
        signal: controller.signal,
      });
      var sourceSignal = requestInit && requestInit.signal
        ? requestInit.signal
        : requestInput && requestInput.signal
          ? requestInput.signal
          : null;
      var timedOut = false;
      var timeoutId = null;
      var forwardAbort = function () {
        try {
          controller.abort();
        } catch (error) {}
      };
      if (sourceSignal) {
        if (sourceSignal.aborted) {
          forwardAbort();
        } else if (typeof sourceSignal.addEventListener === "function") {
          sourceSignal.addEventListener("abort", forwardAbort, { once: true });
        }
      }
      timeoutId = window.setTimeout(function () {
        timedOut = true;
        forwardAbort();
      }, cartRequestTimeout);

      function cleanup() {
        window.clearTimeout(timeoutId);
        if (
          sourceSignal &&
          typeof sourceSignal.removeEventListener === "function"
        ) {
          sourceSignal.removeEventListener("abort", forwardAbort);
        }
      }

      return nativeFetch(requestInput, nextInit)
        .then(function (response) {
          return typeof consumeResponse === "function"
            ? consumeResponse(response, function () { return timedOut; })
            : response;
        })
        .then(
          function (response) {
            cleanup();
            return response;
          },
          function (error) {
            cleanup();
            if (timedOut) {
              throw createError(
                "timeout",
                typeof cartSyncTimeoutLabel === "string"
                  ? cartSyncTimeoutLabel
                  : cartErrorLabel,
                { response: error }
              );
            }
            throw error;
          }
        );
    }
    return enqueue({
      source: options.source,
      execute: function () {
        return fetchWithTimeout(prepared.input, prepared.init, function (
          response,
          didTimeOut
        ) {
          if (!response || !response.ok) {
            return response;
          }
          try {
            return response.clone().json().then(
              function (data) {
                storeSectionsBundle(data, requestRevision);
                return response;
              },
              function (parseError) {
                if (didTimeOut()) {
                  throw parseError;
                }
                return response;
              }
            );
          } catch (cloneError) {
            return response;
          }
        });
      },
      getFailureType: classifyFetchCartResponse,
      resolveFailureResult: options.resolveFailureResult === true,
      showCart: options.showCart,
      trigger: options.trigger,
      visibilityGeneration: options.visibilityGeneration,
      expectedItemCountDelta: typeof options.expectedItemCountDelta === "number"
        ? options.expectedItemCountDelta
        : getCartAddItemCountDelta(input, init),
      managesSectionsBundle: true,
    });
  }

  function holdRefresh(key) {
    key = String(key || "external");
    refreshHolds[key] = (refreshHolds[key] || 0) + 1;
    window.clearTimeout(refreshTimer);
    syncStateChange();
  }

  function releaseRefresh(key) {
    key = String(key || "external");
    if (refreshHolds[key]) {
      refreshHolds[key] -= 1;
      if (refreshHolds[key] <= 0) {
        delete refreshHolds[key];
      }
    }
    syncStateChange();
    scheduleRefresh();
  }

  function showFailure(failureType, message, trigger, generation) {
    if (typeof cartDrawerEnable === "undefined" || !cartDrawerEnable) {
      return;
    }
    if (!canOpenGeneration(generation)) {
      return;
    }
    restoreCartDrawerAfterFailure(
      true,
      toJQueryTrigger(trigger),
      "",
      message || getCartFailureMessage(failureType),
      failureType || "request",
      generation
    );
  }

  return {
    enqueue: enqueue,
    enqueueFetch: enqueueFetch,
    waitForRequestSlot: waitForRequestSlot,
    holdRefresh: holdRefresh,
    releaseRefresh: releaseRefresh,
    showFailure: showFailure,
    classifyFetchResponse: classifyFetchCartResponse,
    classifyError: classifyCartRequestFailure,
    getFailureMessage: getCartFailureMessage,
    reportFailure: function (error, textStatus) {
      var failureType = classifyCartRequestFailure(error, textStatus);
      if (isBlockingFailure(failureType)) {
        setBlocked(failureType, getCartFailureMessage(failureType, error));
      } else {
        syncStateChange();
      }
      return failureType;
    },
    getSyncStatus: function () {
      return getSyncStatusInternal();
    },
    recordServerCart: function (cart) {
      var itemCount = recordCartSnapshot(cart);
      syncStateChange();
      return itemCount;
    },
    acceptAuthoritativeCart: acceptAuthoritativeCart,
    beginUserCartBatch: function () {
      var generation = issueVisibilityGeneration();
      currentBatchBaseline = lastObservedItemCount;
      syncStateChange();
      return generation;
    },
    notifyExternalStateChange: function () {
      syncStateChange();
    },
    notifyDrawerClosed: function () {
      dismissedThroughGeneration = latestIssuedGeneration;
      refreshOpenGeneration = 0;
      jQuery("[data-side-drawer]")
        .attr("aria-hidden", "true")
        .attr("inert", "");
      syncStateChange();
    },
    clearAutoOpenSuppression: function () {
      var generation = issueVisibilityGeneration();
      currentBatchBaseline = lastObservedItemCount;
      syncStateChange();
      return generation;
    },
    canOpenGeneration: function (generation) {
      return canOpenGeneration(generation);
    },
    getCurrentGeneration: function () {
      return latestIssuedGeneration;
    },
    beginManualDrawerOpen: function (trigger) {
      var generation = issueVisibilityGeneration();
      setCartDrawerShell(toJQueryTrigger(trigger), true, generation);
      activateCartDrawer(toJQueryTrigger(trigger), generation);
      var block = getBlock();
      if (block) {
        showFailure(block.type, block.message, trigger, generation);
      }
      syncStateChange();
      return generation;
    },
    notifyDrawerOpen: function (trigger, generation) {
      if (
        expectedItemCount === null &&
        !active &&
        queue.length === 0 &&
        !hasRefreshHolds() &&
        !refreshRequested
      ) {
        return;
      }
      refreshRequested = true;
      refreshVersion += 1;
      var openGeneration = normalizeVisibilityGeneration(generation);
      if (openGeneration > refreshOpenGeneration) {
        refreshOpenGeneration = openGeneration;
      }
      if (trigger) {
        refreshTrigger = trigger;
      }
      scheduleRefresh();
    },
    clearExpiredBlock: function () {
      var block = getBlock();
      syncStateChange();
      return block;
    },
    getDiagnostics: function () {
      return {
        queued: diagnostics.queued,
        completed: diagnostics.completed,
        failed: diagnostics.failed,
        refreshes: diagnostics.refreshes,
        blocked: diagnostics.blocked,
        catchUpAttempts: diagnostics.catchUpAttempts,
        catchUpCompleted: diagnostics.catchUpCompleted,
        catchUpExhausted: diagnostics.catchUpExhausted,
        throttledStarts: diagnostics.throttledStarts,
        minimumMutationInterval: minimumMutationInterval,
        reconcileDelay: cartReconcileDelay,
        sources: jQuery.extend({}, diagnostics.sources),
        pending: queue.length + (active ? 1 : 0),
        blockedType: getBlock() ? getBlock().type : "",
        expectedItemCount: expectedItemCount,
        lastObservedItemCount: lastObservedItemCount,
        latestIssuedGeneration: latestIssuedGeneration,
        dismissedThroughGeneration: dismissedThroughGeneration,
      };
    },
  };
}

window.LumaryCartCoordinator = createCartMutationCoordinator();

function getCartAvailabilityMessage(quantity) {
  var availableQuantity = Number(quantity);
  var template = availableQuantity === 1
    ? cartAvailabilityErrorOne
    : cartAvailabilityErrorOther;
  return template.replace("[qty]", String(availableQuantity));
}

function isMaximumQuantityMessage(message) {
  return String(message || "").toLowerCase().indexOf(
    "the maximum quantity of this item is already in your cart"
  ) > -1;
}

function normalizeCartAvailabilityMessage(message, quantity) {
  if (Number(quantity) > 0 && isMaximumQuantityMessage(message)) {
    return getCartAvailabilityMessage(quantity);
  }
  return message || cartErrorLabel;
}

function showCartPageLineErrorAfterRender(renderRequest, line, message) {
  var showError = function () {
    jQuery("#cartItemError-" + line).text(message || cartErrorLabel);
  };
  if (renderRequest && typeof renderRequest.always === "function") {
    renderRequest.always(showError);
  } else {
    showError();
  }
}

if (window.location.pathname.indexOf("/cart") > -1) {
  // Shipping Estimations

  (function () {
    function shippingEstimates() {
      if (Shopify && Shopify.CountryProvinceSelector) {
        var country = document.getElementById("shippingCountry");
        if (!country) {
          return false;
        }
        var shipping = new Shopify.CountryProvinceSelector(
          "shippingCountry",
          "shippingProvince",
          {
            hideElement: "shippingProvinceContainer",
          }
        );

        setupEventListeners();
      }
    }

    function setupEventListeners() {
      var button = document.getElementById("getShippingEstimates");
      if (button) {
        button.addEventListener("click", (e) => {
          e.preventDefault();
          $("#ShippingWrapperResponse")
            .html("")
            .removeClass("success")
            .removeClass("error")
            .hide();
          var shippingAddress = {};
          shippingAddress.zip = jQuery("#shippingZip").val() || "";
          shippingAddress.country = jQuery("#shippingCountry").val() || "";
          shippingAddress.province = jQuery("#shippingProvince").val() || "";
          _getCartShippingRates(shippingAddress);
        });
      }
    }

    var _getCartShippingRates = function (shippingAddress) {
      var params = {
        type: "POST",
        url: "/cart/shipping_rates.json",
        data: jQuery.param({ shipping_address: shippingAddress }),
        success: function (data) {
          _render(data.shipping_rates);
        },
        error: _onError,
      };
      jQuery.ajax(params);
    };

    var _fullMessagesFromErrors = function (errors) {
      var fullMessages = [];
      jQuery.each(errors, function (attribute, messages) {
        jQuery.each(messages, function (index, message) {
          fullMessages.push(message);
        });
      });
      return fullMessages;
    };
    var _onError = function (XMLHttpRequest, textStatus) {
      var data = {};
      try {
        data = JSON.parse(XMLHttpRequest.responseText || "{}");
      } catch (error) {
        data = { error: [cartErrorLabel] };
      }
      var feedback = _fullMessagesFromErrors(data).join(", ") + ".";
      $("#ShippingWrapperResponse")
        .html('<p class="error-text">' + feedback + "</p>")
        .addClass("error")
        .show();
    };
    var _render = function (response) {
      if (response && response.length > 0) {
        var html = '<p class="success-text">';
        response.forEach(function (shipping) {
          html += `<span><strong>${
            shipping.name
          }:</strong>${Shopify.formatMoney(
            shipping.price * 100,
            moneyFormat
          )}</span>`;
        });
        html += "</p>";
        $("#ShippingWrapperResponse").html(html).addClass("success").show();
      } else {
        $("#ShippingWrapperResponse")
          .html('<p class="error-text">' + notAvailableLabel + "</p>")
          .addClass("error")
          .show();
      }
    };
    setTimeout(function () {
      shippingEstimates();
      $.ajax({
        url: mainCartUrl,
        type: "GET",
        dataType: "json",
        success: function (result) {
          if (result.item_count > 0) {
            freeShippingBar(result);
            upsellCartProducts(result)
          }
        },
      });
    }, 500);

    window.shippingEstimates = shippingEstimates;
  })();

  // Update quantity based on input on change

  changeCartItem = function (line, quantity) {
    var params = {
      type: "POST",
      url: cartChangeUrl,
      data: "quantity=" + quantity + "&line=" + line,
      dataType: "json",
      success: function (cart) {
        // if (quantity == 0) {
        //     $('[name="updates[]"][data-line="' + line + '"]').closest('tr').remove();
        // }
        if (cart.item_count == 0) {
          emptyCartStatus = true;
          // $('[data-cart-form]').hide();
          // $('[data-cart-empty]').show();
          $("[data-cart-count]").hide();
        } else {
          emptyCartStatus = false;
          cartItemsCount = cart.item_count;
          if (favicon) {
            favicon.badge(cartItemsCount);
          }
          $("[data-cart-count]").show();

          var item = cart.items[line - 1];
          if (item) {
            $('[name="updates[]"][data-line="' + line + '"]').val(
              item.quantity
            );
          }
        }
        var item = cart.items[line - 1];
        var availabilityMessage = "";
        if (
          item &&
          quantity !== 0 &&
          Number(item.quantity) !== Number(quantity)
        ) {
          availabilityMessage = getCartAvailabilityMessage(item.quantity);
        }
        var renderRequest = cartPageUpdate(cart);
        if (availabilityMessage) {
          showCartPageLineErrorAfterRender(
            renderRequest,
            line,
            availabilityMessage
          );
        }
      },
      error: function (XMLHttpRequest, textStatus) {
        var requestErrorMessage = getRequestErrorMessage(XMLHttpRequest);
        jQuery.getJSON(cartUrl, function (cart, textStatus) {
          if (quantity == 0) {
            $('[name="updates[]"][data-line="' + line + '"]')
              .closest("tr")
              .remove();
          }
          cartItemsCount = cart.item_count;
          if (favicon) {
            favicon.badge(cartItemsCount);
          }
          if (cart.item_count == 0) {
            // $('[data-cart-form]').hide();
            // $('[data-cart-empty]').show();
            $("[data-cart-count]").hide();
          } else {
            $("[data-cart-count]").show();

            var item = cart.items[line - 1];
            if (item) {
              $('[name="updates[]"][data-line="' + line + '"]').val(
                item.quantity
              );
            }
          }
          var currentItem = cart.items[line - 1];
          var errorMessage = normalizeCartAvailabilityMessage(
            requestErrorMessage,
            currentItem && currentItem.quantity
          );
          var renderRequest = cartPageUpdate(cart);
          showCartPageLineErrorAfterRender(renderRequest, line, errorMessage);
        }).fail(function () {
          showCartPageLineErrorAfterRender(null, line, requestErrorMessage);
        });
      },
    };
    jQuery.ajax(params);
  };

  $(document).on("click", ".line_item_change", function (evt) {
    evt.preventDefault();
    var $el = $(this),
      line = $el.data("line"),
      parent = $el.closest("tr"),
      $qtySelector = $el.siblings('input[name="updates[]"]');

    $("#cartItemError-" + line).html("");
    var qty = parseInt($qtySelector.val().replace(/\D/g, ""));

    parent.addClass("disabled");
    parent.closest("[data-cart-items]").addClass("disabled");
    var qty = validateQty(qty);

    if ($el.hasClass("quantity-up")) {
      qty += 1;
    } else {
      qty -= 1;
      if (qty <= 0) qty = 0;
    }
    $qtySelector.val(qty);
    if (line) {
      changeCartItem(line, qty);
    }
  });

  $(document).on("change", '[name="updates[]"]', function (evt) {
    evt.preventDefault();
    var $el = $(this),
      line = $el.data("line"),
      parent = $el.closest("tr"),
      qty = parseInt($el.val().replace(/\D/g, ""));
    parent.addClass("disabled");
    parent.closest("[data-cart-items]").addClass("disabled");

    $("#cartItemError-" + line).html("");
    qty = validateQty(qty);
    // Add or subtract from the current quantity

    if (line) {
      changeCartItem(line, qty);
    }
  });

  $(document).on("click", ".line_item_remove", function (evt) {
    evt.preventDefault();
    var $el = $(this),
      parent = $el.closest("tr"),
      line = $el.data("line");
    // If it has a data-line, update the cart
    if (line) {
      parent.addClass("disabled");
      parent.closest("[data-cart-items]").addClass("disabled");
      changeCartItem(line, 0);
    }
  });
} else {
  var cartLineUpdateStates = {};
  var cartLineUpdateQueue = [];
  var cartLineUpdateActive = false;
  var cartClearPending = false;
  var cartClearRequest = null;
  var cartClearBarrierPromise = null;
  var cartClearBarrierRelease = null;
  var cartClearDialogTrigger = null;
  var cartLineNotices = {};
  var cartQuantityRefreshHeld = false;
  var cartQuantityUpdatedCart = null;
  var cartQuantityQueueConfig = window.LumaryCartQueueConfig || {};
  var cartQuantitySettleDelay = Number(
    cartQuantityQueueConfig.quantitySettleDelay
  );
  if (!Number.isFinite(cartQuantitySettleDelay)) {
    var cartQuantityCoarsePointer = false;
    try {
      cartQuantityCoarsePointer = !!(
        window.matchMedia && window.matchMedia("(pointer: coarse)").matches
      );
    } catch (error) {}
    cartQuantitySettleDelay = cartQuantityCoarsePointer ? 750 : 600;
  }
  cartQuantitySettleDelay = Math.min(
    2000,
    Math.max(250, Math.floor(cartQuantitySettleDelay))
  );

  function rememberCartLineNotice(line, message) {
    if (!line || !message) {
      return;
    }
    cartLineNotices[String(line)] = message;
  }

  function clearCartLineNotice(line) {
    delete cartLineNotices[String(line)];
  }

  function renderCartLineNotices() {
    jQuery.each(cartLineNotices, function (line, message) {
      jQuery("#cartDrawerItemError-" + line).text(message);
    });
  }

  function getCartLine(itemKey, line) {
    var key = String(itemKey || "");
    var cartLine = jQuery();
    if (key) {
      cartLine = jQuery(".media-link").filter(function () {
        return String(jQuery(this).attr("data-id") || "") === key;
      }).first();
    }
    if (!cartLine.length && line) {
      cartLine = jQuery('.media-link[data-line="' + line + '"]').first();
    }
    return cartLine;
  }

  function setCartLineBusy(itemKey, line, isBusy) {
    var cartLine = getCartLine(itemKey, line);
    if (isBusy) {
      cartLine.attr("aria-busy", "true").attr("data-cart-line-syncing", "");
      return;
    }
    cartLine.removeAttr("aria-busy").removeAttr("data-cart-line-syncing");
  }

  function beginCartQuantitySync() {
    if (!cartQuantityRefreshHeld) {
      window.LumaryCartCoordinator.holdRefresh("drawer-quantity");
      cartQuantityRefreshHeld = true;
    }
  }

  function releaseCartQuantitySyncIfIdle() {
    // GLM-FIX: idle conditions alone decide. The controls lock must never
    // depend on the refresh-hold bookkeeping staying in sync — if any path
    // ever released the hold without passing through here, the buttons
    // would stay disabled forever.
    if (
      !cartLineUpdateActive &&
      cartLineUpdateQueue.length === 0 &&
      Object.keys(cartLineUpdateStates).length === 0 &&
      !cartClearPending &&
      !cartClearRequest
    ) {
      if (cartQuantityRefreshHeld) {
        window.LumaryCartCoordinator.releaseRefresh("drawer-quantity");
        cartQuantityRefreshHeld = false;
      }
      releaseCartControls("drawer-quantity");
      if (cartQuantityUpdatedCart) {
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:updated", {
            detail: {
              cart: cartQuantityUpdatedCart,
              source: "drawer-quantity",
            },
          })
        );
        cartQuantityUpdatedCart = null;
      }
    }
  }

  function showCartLineError(itemKey, line, message) {
    var key = String(itemKey || "");
    var cartLine = getCartLine(key, line);
    var errorContainer = cartLine.find(".cart-item-error").first();
    if (!errorContainer.length && line) {
      errorContainer = jQuery("#cartDrawerItemError-" + line);
    }
    errorContainer.text(
      typeof message === "string" ? message : cartErrorLabel
    );
  }

  function getCartLineStateId(itemKey, line) {
    var key = String(itemKey || "");
    return key ? "key:" + key : "line:" + line;
  }

  function moveCartLineUpdateState(state, itemKey, line) {
    var previousId = state.id;
    state.key = String(itemKey || "");
    state.line = Number(line);
    state.id = getCartLineStateId(state.key, state.line);
    if (previousId !== state.id) {
      delete cartLineUpdateStates[previousId];
      cartLineUpdateStates[state.id] = state;
    }
  }

  var cartControlsBusySources = {};

  // Single source of truth for disabling every cart-mutating control in the
  // drawer (+/- buttons, quantity inputs, remove and clear buttons). Multiple
  // sources (quantity sync cycle, cart clear) can hold the lock at the same
  // time; controls are only re-enabled when the last source releases.
  function syncCartControlsBusyState() {
    var busy = Object.keys(cartControlsBusySources).length > 0;
    var drawer = jQuery("[data-drawer-body]");
    var controls = jQuery(".mini_cart").find(
      ".quantity-button, .ajaxcart__qty-num, .sd_mini_removeproduct, [data-clear-cart]"
    );
    if (busy) {
      drawer.attr("aria-busy", "true");
      controls.each(function () {
        var control = jQuery(this);
        if (
          typeof control.data("cartControlsOriginalDisabled") === "undefined"
        ) {
          control.data(
            "cartControlsOriginalDisabled",
            control.prop("disabled")
          );
        }
        control.prop("disabled", true);
      });
      return;
    }
    drawer.removeAttr("aria-busy");
    controls.each(function () {
      var control = jQuery(this);
      var originalDisabled = control.data("cartControlsOriginalDisabled");
      if (typeof originalDisabled !== "undefined") {
        control.prop("disabled", originalDisabled);
        control.removeData("cartControlsOriginalDisabled");
      }
    });
  }

  function holdCartControls(source) {
    cartControlsBusySources[String(source || "generic")] = true;
    syncCartControlsBusyState();
  }

  function releaseCartControls(source) {
    delete cartControlsBusySources[String(source || "generic")];
    syncCartControlsBusyState();
  }

  function setCartClearBusy(isBusy) {
    if (isBusy) {
      holdCartControls("cart-clear");
    } else {
      releaseCartControls("cart-clear");
    }
  }

  function showCartClearError(message) {
    jQuery("[data-cart-clear-error]").text(message || "");
  }

  changeItem = function (itemKey, line, quantity, resolveQuantity) {
    var key = String(itemKey || "");
    var ticket = window.LumaryCartCoordinator.enqueue({
      source: "drawer-quantity",
      showCart: false,
      skipRefresh: true,
      execute: function () {
        return new Promise(function (resolve, reject) {
          function rejectRequest(XMLHttpRequest, textStatus, errorThrown) {
            reject({
              xhr: XMLHttpRequest,
              textStatus: textStatus,
              errorThrown: errorThrown,
            });
          }

          function postChange(resolvedQuantity) {
            var data = {
              quantity: resolvedQuantity.quantity,
              sections: cartDrawerSectionId,
              sections_url: getCartSectionsUrl(),
            };
            if (resolvedQuantity.key) {
              data.id = resolvedQuantity.key;
            } else {
              data.line = resolvedQuantity.line;
            }
            jQuery.ajax({
              type: "POST",
              url: cartChangeUrl,
              data: data,
              dataType: "json",
              timeout: cartRequestTimeout,
            })
              .done(resolve)
              .fail(rejectRequest);
          }

          if (typeof resolveQuantity !== "function") {
            postChange({
              key: key,
              line: line,
              quantity: quantity,
            });
            return;
          }

          // A PageFly batch can hold captured clicks outside the coordinator
          // until each real response has settled. Resolve the user's queued
          // +/- intent from the latest server quantity inside this same
          // serialized mutation, so an older absolute value cannot overwrite
          // an add that was clicked first.
          jQuery.ajax({
            type: "GET",
            url: cartUrl,
            dataType: "json",
            timeout: cartRequestTimeout,
          })
            .done(function (cart) {
              var resolvedQuantity;
              try {
                resolvedQuantity = resolveQuantity(cart);
              } catch (error) {
                reject({
                  xhr: null,
                  textStatus: "resolvererror",
                  errorThrown: error,
                });
                return;
              }
              var slot = typeof window.LumaryCartCoordinator.waitForRequestSlot === "function"
                ? window.LumaryCartCoordinator.waitForRequestSlot()
                : Promise.resolve();
              slot.then(function () {
                postChange(resolvedQuantity);
              }, function (slotError) {
                reject({
                  xhr: null,
                  textStatus: "queueerror",
                  errorThrown: slotError,
                });
              });
            })
            .fail(rejectRequest);
        });
      },
    });
    var deferred = jQuery.Deferred();
    ticket.mutation.then(
      function (cart) {
        deferred.resolve(cart);
      },
      function (error) {
        deferred.reject(error && error.xhr ? error.xhr : error);
      }
    );
    return deferred.promise();
  };

  function findCartItemForState(cart, state) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    var itemIndex = -1;
    var canUseIdentityFallback = Number(state.requestedQuantity) !== 0;
    if (state.key) {
      itemIndex = items.findIndex(function (item) {
        return String(item && item.key || "") === state.key;
      });
    }
    if (
      itemIndex < 0 &&
      canUseIdentityFallback &&
      state.line > 0 &&
      items[state.line - 1]
    ) {
      var lineCandidate = items[state.line - 1];
      var stateVariantId = String(state.key || "").split(":")[0];
      var candidateVariantId = String(
        lineCandidate && (lineCandidate.variant_id || lineCandidate.id) || ""
      );
      if (!stateVariantId || stateVariantId === candidateVariantId) {
        itemIndex = state.line - 1;
      }
    }
    if (itemIndex < 0 && canUseIdentityFallback && state.key) {
      var expectedVariantId = String(state.key).split(":")[0];
      var matchingVariantIndexes = [];
      items.forEach(function (item, index) {
        if (
          String(item && (item.variant_id || item.id) || "") ===
          expectedVariantId
        ) {
          matchingVariantIndexes.push(index);
        }
      });
      if (matchingVariantIndexes.length === 1) {
        itemIndex = matchingVariantIndexes[0];
      }
    }
    return {
      item: itemIndex > -1 ? items[itemIndex] : null,
      line: itemIndex > -1 ? itemIndex + 1 : state.line,
    };
  }

  function restoreOptimisticCartLineQuantity(state) {
    var cartLine = getCartLine(state.key, state.line);
    var quantityInput = cartLine.find(".ajaxcart__qty-num").first();
    if (!quantityInput.length) {
      return;
    }
    quantityInput
      .val(state.desiredQuantity)
      .attr("data-cart-confirmed-quantity", state.confirmedQuantity);
    cartLine
      .find(".ajaxcart__qty--minus")
      .attr("data-qty", Math.max(0, state.desiredQuantity - 1));
    cartLine
      .find(".ajaxcart__qty--plus")
      .attr("data-qty", state.desiredQuantity + 1);
  }

  function renderDrawerCartMutation(cart, callback) {
    window.LumaryCartCoordinator.recordServerCart(cart);
    var sectionResult = null;
    if (cart && cart.sections) {
      sectionResult = getCartDrawerSectionResult(cart.sections);
    }
    if (sectionResult && isCartDrawerHtml(sectionResult.html)) {
      var deferred = jQuery.Deferred();
      try {
        cart.drawer_item_count = sectionResult.itemCount;
        applyCartDrawerHtml(sectionResult, cart, false, null, 0);
        deferred.resolve(sectionResult);
      } catch (error) {
        deferred.reject(null, "rendererror", error);
      }
      return deferred.promise();
    }
    return callback(cart, false);
  }

  function getCartLineSettleDelay(state) {
    if (state.lastIntentType === "absolute") {
      return 0;
    }
    return Math.max(
      0,
      cartQuantitySettleDelay - (Date.now() - state.lastIntentAt)
    );
  }

  function scheduleCartLineUpdate(state) {
    if (state.timer) {
      window.clearTimeout(state.timer);
      state.timer = null;
    }
    if (state.inFlight || state.queued) {
      return;
    }
    state.timer = window.setTimeout(function () {
      state.timer = null;
      queueCartLineUpdate(state);
    }, getCartLineSettleDelay(state));
  }

  // Runs one step of a cart-line update continuation. If the step throws
  // (e.g. a render callback exploding on stale DOM), the line is rolled back
  // and the queue is still released, so one bad render can never leave
  // cartLineUpdateActive stuck at true (the old "cart dead until page
  // refresh" failure mode).
  function runCartLineUpdateStep(state, step) {
    try {
      return step();
    } catch (error) {
      try {
        state.desiredQuantity = state.confirmedQuantity;
        state.requestedQuantity = state.confirmedQuantity;
        state.pendingAbsoluteQuantity = null;
        restoreOptimisticCartLineQuantity(state);
        showCartLineError(state.key, state.line, cartErrorLabel);
      } catch (nestedError) {}
      state.inFlight = false;
      cartLineUpdateActive = false;
      try {
        finishCartLineUpdate(state);
      } catch (finishError) {
        try {
          processCartLineUpdateQueue();
        } catch (processError) {}
      }
      return null;
    }
  }

  // After a drawer re-render, re-apply the optimistic quantities of other
  // lines that still have pending (not yet submitted) intents, so the render
  // of line A does not visually wipe out what the user clicked on line B.
  function restorePendingCartLineQuantities(excludedState) {
    jQuery.each(cartLineUpdateStates, function (_stateId, otherState) {
      if (
        otherState !== excludedState &&
        otherState.desiredQuantity !== otherState.confirmedQuantity
      ) {
        restoreOptimisticCartLineQuantity(otherState);
      }
    });
  }

  function finishCartLineUpdate(state) {
    if (!state.inFlight && cartLineUpdateStates[state.id] !== state) {
      return;
    }
    state.inFlight = false;
    setCartLineBusy(state.key, state.line, false);
    if (
      state.desiredQuantity !== state.confirmedQuantity ||
      state.pendingAbsoluteQuantity !== null
    ) {
      scheduleCartLineUpdate(state);
    } else {
      delete cartLineUpdateStates[state.id];
    }
    cartLineUpdateActive = false;
    processCartLineUpdateQueue();
    releaseCartQuantitySyncIfIdle();
  }

  function reconcileCartLineUpdate(state, errorMessage, clampToActual) {
    var reconciliationTicket = window.LumaryCartCoordinator.enqueue({
      source: "drawer-quantity-reconcile",
      showCart: false,
      skipRefresh: true,
      execute: function () {
        return new Promise(function (resolve, reject) {
          jQuery.ajax({
            url: cartUrl,
            type: "GET",
            dataType: "json",
            timeout: cartRequestTimeout,
          })
            .done(resolve)
            .fail(function (XMLHttpRequest, textStatus, errorThrown) {
              reject({
                xhr: XMLHttpRequest,
                textStatus: textStatus,
                errorThrown: errorThrown,
              });
            });
        });
      },
    });
    reconciliationTicket.mutation.then(
      function (cart) {
        runCartLineUpdateStep(state, function () {
        cartQuantityUpdatedCart = cart;
        window.LumaryCartCoordinator.recordServerCart(cart);
        var match = findCartItemForState(cart, state);
        var currentItem = match.item;
        var actualQuantity = currentItem ? Number(currentItem.quantity) : 0;
        if (currentItem) {
          moveCartLineUpdateState(state, currentItem.key, match.line);
        }
        state.confirmedQuantity = actualQuantity;
        if (
          state.revision <= state.requestedRevision ||
          (clampToActual && state.desiredQuantity > actualQuantity)
        ) {
          state.desiredQuantity = actualQuantity;
        }
        state.requestedQuantity = actualQuantity;
        var normalizedErrorMessage = normalizeCartAvailabilityMessage(
          errorMessage,
          actualQuantity
        );
        rememberCartLineNotice(state.line, normalizedErrorMessage);
        var renderTicket = window.LumaryCartCoordinator.enqueue({
          source: "drawer-quantity-reconcile-render",
          showCart: false,
          skipRefresh: true,
          execute: function () {
            return state.callback(cart, false) || cart;
          },
        });
        renderTicket.mutation.then(
          function () {
            runCartLineUpdateStep(state, function () {
            restorePendingCartLineQuantities(state);
            if (state.desiredQuantity !== state.confirmedQuantity) {
              restoreOptimisticCartLineQuantity(state);
            }
            showCartLineError(
              state.key,
              state.line,
              normalizedErrorMessage
            );
            finishCartLineUpdate(state);
            });
          },
          function () {
            runCartLineUpdateStep(state, function () {
            state.desiredQuantity = state.confirmedQuantity;
            state.requestedQuantity = state.confirmedQuantity;
            restoreOptimisticCartLineQuantity(state);
            showCartLineError(
              state.key,
              state.line,
              normalizedErrorMessage
            );
            finishCartLineUpdate(state);
            });
          }
        );
        });
      },
      function (error) {
        runCartLineUpdateStep(state, function () {
        state.desiredQuantity = state.confirmedQuantity;
        state.requestedQuantity = state.confirmedQuantity;
        restoreOptimisticCartLineQuantity(state);
        showCartLineError(
          state.key,
          state.line,
          getRequestErrorMessage(error && error.xhr ? error.xhr : error) ||
            errorMessage
        );
        finishCartLineUpdate(state);
        });
      }
    );
  }

  function processCartLineUpdateQueue() {
    if (cartLineUpdateActive) {
      return;
    }
    if (!cartLineUpdateQueue.length) {
      processCartClearQueue();
      releaseCartQuantitySyncIfIdle();
      return;
    }
    var state = cartLineUpdateQueue.shift();
    state.queued = false;
    if (!cartLineUpdateStates[state.id]) {
      processCartLineUpdateQueue();
      return;
    }
    if (getCartLineSettleDelay(state) > 0) {
      scheduleCartLineUpdate(state);
      processCartLineUpdateQueue();
      return;
    }
    cartLineUpdateActive = true;
    state.inFlight = true;
    holdCartControls("drawer-quantity");
    var resolveAgainstServer = state.resolveAgainstServer;
    var authoritativeBaseQuantity = state.authoritativeBaseQuantity;
    var requestedDesiredQuantity = state.desiredQuantity;
    var requestedAbsoluteQuantity = state.pendingAbsoluteQuantity;
    state.resolveAgainstServer = false;
    state.authoritativeBaseQuantity = null;
    state.pendingAbsoluteQuantity = null;
    state.requestedQuantity = state.desiredQuantity;
    state.requestedRevision = state.revision;
    setCartLineBusy(state.key, state.line, true);
    changeItem(
      state.key,
      state.line,
      state.requestedQuantity,
      resolveAgainstServer
        ? function (serverCart) {
            var match = findCartItemForState(serverCart, state);
            var actualQuantity = match.item
              ? Number(match.item.quantity)
              : 0;
            if (match.item) {
              moveCartLineUpdateState(state, match.item.key, match.line);
            }
            var requestedQuantity = requestedAbsoluteQuantity !== null
              ? requestedAbsoluteQuantity
              : Math.max(
                  0,
                  actualQuantity +
                    requestedDesiredQuantity -
                    authoritativeBaseQuantity
                );
            var laterDesiredQuantity = state.pendingAbsoluteQuantity !== null
              ? state.pendingAbsoluteQuantity
              : Math.max(
                  0,
                  requestedQuantity +
                    state.desiredQuantity -
                    requestedDesiredQuantity
                );
            state.confirmedQuantity = actualQuantity;
            state.requestedQuantity = requestedQuantity;
            state.desiredQuantity = laterDesiredQuantity;
            restoreOptimisticCartLineQuantity(state);
            return {
              key: state.key,
              line: state.line,
              quantity: requestedQuantity,
            };
          }
        : null
    )
      .done(function (cart) {
        runCartLineUpdateStep(state, function () {
        cartQuantityUpdatedCart = cart;
        var match = findCartItemForState(cart, state);
        var currentItem = match.item;
        var actualQuantity = currentItem ? Number(currentItem.quantity) : 0;
        var requestedQuantity = Number(state.requestedQuantity);
        if (currentItem) {
          moveCartLineUpdateState(state, currentItem.key, match.line);
        }
        var lineErrorMessage = "";
        if (
          currentItem &&
          requestedQuantity !== 0 &&
          actualQuantity !== requestedQuantity
        ) {
          lineErrorMessage = getCartAvailabilityMessage(
            actualQuantity
          );
          rememberCartLineNotice(state.line, lineErrorMessage);
          state.confirmedQuantity = actualQuantity;
          if (
            state.revision <= state.requestedRevision ||
            state.desiredQuantity > actualQuantity
          ) {
            state.desiredQuantity = actualQuantity;
          }
          state.requestedQuantity = actualQuantity;
        } else if (currentItem || requestedQuantity === 0) {
          state.confirmedQuantity = actualQuantity;
          clearCartLineNotice(state.line);
        } else {
          var hadLaterQuantityIntent =
            state.revision > state.requestedRevision ||
            state.pendingAbsoluteQuantity !== null;
          state.requestedQuantity = state.desiredQuantity;
          state.confirmedQuantity = state.desiredQuantity;
          state.pendingAbsoluteQuantity = null;
          if (hadLaterQuantityIntent) {
            lineErrorMessage = cartErrorLabel;
            rememberCartLineNotice(state.line, lineErrorMessage);
          } else {
            clearCartLineNotice(state.line);
          }
        }
        var renderRequest = renderDrawerCartMutation(cart, state.callback);
        if (renderRequest && typeof renderRequest.always === "function") {
          renderRequest.always(function () {
            runCartLineUpdateStep(state, function () {
            restorePendingCartLineQuantities(state);
            if (state.desiredQuantity !== state.confirmedQuantity) {
              restoreOptimisticCartLineQuantity(state);
            }
            if (lineErrorMessage) {
              showCartLineError(
                state.key,
                state.line,
                lineErrorMessage
              );
            }
            finishCartLineUpdate(state);
            });
          });
        } else {
          restorePendingCartLineQuantities(state);
          if (state.desiredQuantity !== state.confirmedQuantity) {
            restoreOptimisticCartLineQuantity(state);
          }
          if (lineErrorMessage) {
            showCartLineError(state.key, state.line, lineErrorMessage);
          }
          finishCartLineUpdate(state);
        }
        });
      })
      .fail(function (XMLHttpRequest) {
        runCartLineUpdateStep(state, function () {
        var failureType = classifyCartRequestFailure(XMLHttpRequest);
        if (isBlockingFailure(failureType)) {
          state.desiredQuantity = state.confirmedQuantity;
          state.requestedQuantity = state.confirmedQuantity;
          restoreOptimisticCartLineQuantity(state);
          showCartLineError(
            state.key,
            state.line,
            getRequestErrorMessage(XMLHttpRequest)
          );
          finishCartLineUpdate(state);
          return;
        }
        var requestErrorMessage = getRequestErrorMessage(XMLHttpRequest);
        reconcileCartLineUpdate(
          state,
          requestErrorMessage,
          Number(XMLHttpRequest && XMLHttpRequest.status) === 422 ||
            isMaximumQuantityMessage(requestErrorMessage)
        );
        });
      });
  }

  function queueCartLineUpdate(state) {
    var pageflyBridge = window.LumaryPageFlyCartBridge;
    var pageflyStats = pageflyBridge &&
      typeof pageflyBridge.getStats === "function"
      ? pageflyBridge.getStats()
      : null;
    if (
      !state.inFlight &&
      Number(pageflyStats && pageflyStats.pending) > 0 &&
      typeof pageflyBridge.whenIdle === "function"
    ) {
      if (!state.waitingForPageFly) {
        state.waitingForPageFly = true;
        state.authoritativeBaseQuantity = state.confirmedQuantity;
        pageflyBridge.whenIdle().then(function () {
          if (cartLineUpdateStates[state.id] !== state) {
            return;
          }
          state.waitingForPageFly = false;
          state.resolveAgainstServer = true;
          queueCartLineUpdate(state);
        });
      }
      return;
    }
    if (!state.queued && !state.inFlight) {
      state.queued = true;
      cartLineUpdateQueue.push(state);
    }
    processCartLineUpdateQueue();
  }

  updateQuantity = function (itemKey, line, qty, callback, quantityIntent) {
    var quantity = Number(qty);
    var key = String(itemKey || "");
    var lineNumber = Number(line);
    if (
      !Number.isInteger(lineNumber) ||
      lineNumber < 1 ||
      !Number.isInteger(quantity) ||
      quantity < 0 ||
      cartClearPending ||
      cartClearRequest
    ) {
      return false;
    }
    var stateId = getCartLineStateId(key, lineNumber);
    clearCartLineNotice(lineNumber);
    showCartLineError(key, lineNumber, "");
    var state = cartLineUpdateStates[stateId];
    if (!state) {
      var cartLine = getCartLine(key, lineNumber);
      var confirmedQuantity = Number(
        cartLine
          .find(".ajaxcart__qty-num")
          .first()
          .attr("data-cart-confirmed-quantity")
      );
      if (!Number.isFinite(confirmedQuantity)) {
        confirmedQuantity = quantity;
      }
      state = {
        id: stateId,
        key: key,
        line: lineNumber,
        confirmedQuantity: confirmedQuantity,
        desiredQuantity: quantity,
        requestedQuantity: null,
        revision: 0,
        requestedRevision: 0,
        callback: callback,
        timer: null,
        queued: false,
        inFlight: false,
        waitingForPageFly: false,
        resolveAgainstServer: false,
        authoritativeBaseQuantity: null,
        pendingAbsoluteQuantity: null,
        lastIntentAt: Date.now(),
        lastIntentType: quantityIntent || "delta",
      };
      cartLineUpdateStates[stateId] = state;
    }
    state.line = lineNumber;
    state.desiredQuantity = quantity;
    state.revision += 1;
    state.callback = callback;
    state.lastIntentAt = Date.now();
    state.lastIntentType = quantityIntent || "delta";
    if (
      quantityIntent === "absolute" ||
      state.pendingAbsoluteQuantity !== null
    ) {
      state.pendingAbsoluteQuantity = quantity;
    }
    beginCartQuantitySync();
    scheduleCartLineUpdate(state);
    restoreOptimisticCartLineQuantity(state);
    return true;
  };

  function cancelPendingCartLineUpdates() {
    jQuery.each(cartLineUpdateStates, function (_stateId, state) {
      if (state.timer) {
        clearTimeout(state.timer);
        state.timer = null;
      }
      if (state.inFlight) {
        state.desiredQuantity = state.requestedQuantity;
        state.pendingAbsoluteQuantity = null;
        state.resolveAgainstServer = false;
        state.authoritativeBaseQuantity = null;
      } else {
        state.waitingForPageFly = false;
        delete cartLineUpdateStates[state.id];
      }
    });
    cartLineUpdateQueue = [];
    releaseCartQuantitySyncIfIdle();
  }

  function processCartClearQueue() {
    if (!cartClearPending || cartClearRequest || cartLineUpdateActive) {
      return;
    }
    if (cartClearBarrierPromise && !cartClearBarrierRelease) {
      return;
    }
    cartClearPending = false;
    setCartClearBusy(true);
    showCartClearError("");
    var clearGeneration = window.LumaryCartCoordinator.getCurrentGeneration();
    cartClearRequest = window.LumaryCartCoordinator.enqueue({
      source: "drawer-clear",
      showCart: false,
      visibilityGeneration: clearGeneration,
      skipRefresh: true,
      execute: function () {
        return new Promise(function (resolve, reject) {
          jQuery.ajax({
            type: "POST",
            url: cartClearUrl,
            data: {
              sections: cartDrawerSectionId,
              sections_url: getCartSectionsUrl(),
            },
            dataType: "json",
            timeout: cartRequestTimeout,
          })
            .done(resolve)
            .fail(function (XMLHttpRequest, textStatus, errorThrown) {
              reject({
                xhr: XMLHttpRequest,
                textStatus: textStatus,
                errorThrown: errorThrown,
              });
            });
        });
      },
    });
    cartClearRequest.mutation.then(
      function (cart) {
        var finishClear = function () {
          setCartClearBusy(false);
          cartClearRequest = null;
          releaseCartClearBarrier();
          releaseCartQuantitySyncIfIdle();
        };
        try {
          cartLineUpdateStates = {};
          cartLineUpdateQueue = [];
          cartLineNotices = {};
          lastSuccessfulDrawerHtml = "";
          cartQuantityUpdatedCart = cart;
          window.LumaryCartCoordinator.acceptAuthoritativeCart(cart);
          var renderRequest = renderDrawerCartMutation(cart, buildCart);
          if (renderRequest && typeof renderRequest.always === "function") {
            renderRequest.always(finishClear);
          } else {
            finishClear();
          }
        } catch (renderError) {
          finishClear();
        }
      },
      function (error) {
        try {
          showCartClearError(
            getRequestErrorMessage(error && error.xhr ? error.xhr : error)
          );
        } catch (messageError) {}
        setCartClearBusy(false);
        cartClearRequest = null;
        releaseCartClearBarrier();
        releaseCartQuantitySyncIfIdle();
      }
    );
  }

  function releaseCartClearBarrier() {
    var release = cartClearBarrierRelease;
    cartClearBarrierPromise = null;
    cartClearBarrierRelease = null;
    if (typeof release === "function") {
      try {
        release();
      } catch (releaseError) {}
    }
  }

  function clearCart() {
    if (cartClearPending || cartClearRequest) {
      return;
    }
    cartClearPending = true;
    beginCartQuantitySync();
    cancelPendingCartLineUpdates();
    setCartClearBusy(true);
    var pageflyBridge = window.LumaryPageFlyCartBridge;
    if (
      pageflyBridge &&
      typeof pageflyBridge.enqueueBarrier === "function"
    ) {
      try {
        cartClearBarrierPromise = pageflyBridge
          .enqueueBarrier()
          .then(function (release) {
            if (!cartClearPending) {
              if (typeof release === "function") {
                release();
              }
              return;
            }
            cartClearBarrierRelease = release;
            processCartClearQueue();
          })
          // GLM-FIX: a rejected barrier used to leave cartClearPending
          // stuck at true, which blocks releaseCartQuantitySyncIfIdle()
          // forever and keeps every cart control disabled until refresh.
          .catch(function () {
            cartClearBarrierPromise = null;
            cartClearBarrierRelease = null;
            if (cartClearPending) {
              cartClearPending = false;
              setCartClearBusy(false);
            }
            releaseCartQuantitySyncIfIdle();
          });
      } catch (bridgeError) {
        cartClearBarrierPromise = null;
      }
    }
    processCartLineUpdateQueue();
  }

  function bindCartClearDialog(dialog) {
    if (dialog.getAttribute("data-cart-clear-dialog-bound") === "true") {
      return;
    }
    dialog.setAttribute("data-cart-clear-dialog-bound", "true");
    dialog.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        event.stopPropagation();
      }
    });
    dialog.addEventListener("cancel", function (event) {
      event.preventDefault();
      dialog.close("cancel");
    });
    dialog.addEventListener("click", function (event) {
      if (event.target === dialog) {
        dialog.close("cancel");
      }
    });
    dialog.addEventListener("close", function () {
      var confirmed = dialog.returnValue === "confirm";
      var trigger = cartClearDialogTrigger;
      cartClearDialogTrigger = null;
      if (trigger && document.documentElement.contains(trigger)) {
        trigger.focus({ preventScroll: true });
      }
      if (confirmed) {
        clearCart();
      }
    });
  }

  function openCartClearDialog(trigger) {
    if (cartClearPending || cartClearRequest) {
      return;
    }
    var dialog = document.querySelector("[data-cart-clear-dialog]");
    if (!dialog || typeof dialog.showModal !== "function" || dialog.open) {
      return;
    }
    bindCartClearDialog(dialog);
    cartClearDialogTrigger = trigger;
    dialog.returnValue = "";
    dialog.showModal();
    var cancelButton = dialog.querySelector("[data-cart-clear-cancel]");
    if (cancelButton) {
      cancelButton.focus({ preventScroll: true });
    }
  }

  jQuery(document).on("click", "[data-js-gift-card-selector]", function () {
    if (!this.checked) {
      jQuery(this)
        .closest("[data-gift-card-box]")
        .find('[type="email"], input[name="properties[Recipient name]"]')
        .val("");
    }
  });

  if (cartDrawerEnable) {
    // POST to cart/add.js returns the cart in JSON
    $("body").on("click", ".Sd_addProduct", function (evt) {
      evt.preventDefault();

      var submit = $(this);
      var form = submit.closest("form");
      if (submit.hasClass("Sd_addProductSticky")) {
        form = jQuery("#" + submit.attr("form"));
      }
      if (!form.length || form.data("cartAddRequest")) {
        return;
      }
      if (form.closest(".yv_side_drawer_wrapper").length == 0) {
        focusElement = submit;
      }
      var addGeneration = window.LumaryCartCoordinator.beginUserCartBatch();
      var parentSection = form.closest(".shopify-section");
      var formElement = form[0];
      var formId = form.attr("id");
      var relatedButtons = jQuery(".Sd_addProduct").filter(function () {
        var button = jQuery(this);
        return (
          this === submit[0] ||
          button.closest("form")[0] === formElement ||
          (formId && button.attr("form") === formId)
        );
      });
      var payload = form.serialize();

      function setAddToCartBusy(isBusy) {
        relatedButtons.each(function () {
          var button = jQuery(this);
          if (isBusy) {
            button.data("cartOriginalDisabled", button.prop("disabled"));
            button.data("cartOriginalAriaBusy", button.attr("aria-busy"));
            button.data("cartOriginalLoading", button.hasClass("is-loading"));
            button.addClass("is-loading").prop("disabled", true).attr("aria-busy", "true");
          } else {
            var originalDisabled = button.data("cartOriginalDisabled");
            var originalAriaBusy = button.data("cartOriginalAriaBusy");
            var originalLoading = button.data("cartOriginalLoading");
            button.toggleClass("is-loading", originalLoading === true);
            if (typeof originalDisabled !== "undefined") {
              button.prop("disabled", originalDisabled);
            }
            if (typeof originalAriaBusy === "undefined") {
              button.removeAttr("aria-busy");
            } else {
              button.attr("aria-busy", originalAriaBusy);
            }
            button.removeData("cartOriginalDisabled");
            button.removeData("cartOriginalAriaBusy");
            button.removeData("cartOriginalLoading");
          }
        });
      }

      function finishAddToCart() {
        form.removeData("cartAddRequest");
        setAddToCartBusy(false);
      }

      function showAddToCartError(XMLHttpRequest) {
        var errorContainer = parentSection.find(".productErrors").first();
        if (!errorContainer.length) {
          return;
        }
        var data = getRequestErrorData(XMLHttpRequest);
        var giftCardWrapper = form.find("[data-gift-card-box]");
        var emailError = data.errors && data.errors.email;
        if (giftCardWrapper.length && emailError) {
          var giftCardEmail = giftCardWrapper.find('[type="email"]').first();
          var emailMessage = getRequestErrorsMessage(emailError) ||
            getRequestErrorMessage(XMLHttpRequest);
          var emailLabel = giftCardEmail.attr("data-attr") || "";
          errorContainer
            .attr("role", "alert")
            .text((emailLabel ? emailLabel + " " : "") + emailMessage)
            .show();
          return;
        }
        var errorMessage = getRequestErrorMessage(XMLHttpRequest);
        var variantId = Number(form.find('[name="id"]').val());
        errorContainer.attr("role", "alert").text(errorMessage).show();
        if (!variantId || !isMaximumQuantityMessage(errorMessage)) {
          return;
        }
        jQuery.getJSON(cartUrl, function (cart) {
          var currentItem = cart.items.find(function (item) {
            return Number(item.variant_id) === variantId;
          });
          if (currentItem) {
            errorContainer
              .text(getCartAvailabilityMessage(currentItem.quantity))
              .show();
          }
        });
      }

      parentSection.find(".productErrors").hide().html("");
      setAddToCartBusy(true);
      function handleAddToCartSuccess(line_item) {
          var quickAddPopup = form.closest(".quick-add-popup");
          var quickAddBody = form.closest("[quick-add-body]");
          if (quickAddPopup.length > 0) {
            quickAddPopup[0].classList.remove("show");
            if (quickAddBody.length > 0) {
              quickAddBody[0].innerHTML = "";
            }
            document.body.classList.remove('quick-add-popup-open');
          }

          $("body").removeClass("quickview-open");
          var addToCartAlert = document.getElementById("addToCartAlert");
          if (addToCartAlert && typeof addToCartAlert.play === "function") {
            try {
              var playPromise = addToCartAlert.play();
              if (playPromise && typeof playPromise.catch === "function") {
                playPromise.catch(function () {});
              }
            } catch (error) {}
          }
          if (hapticFeedbackStatus) {
            const canVibrate = window.navigator.vibrate;
            if (canVibrate) {
              try {
                window.navigator.vibrate(500);
              } catch (error) {}
            }
          }
      }

      var addTicket = window.LumaryCartCoordinator.enqueue({
        source: "theme-product",
        showCart: true,
        trigger: submit[0],
        visibilityGeneration: addGeneration,
        execute: function () {
          return new Promise(function (resolve, reject) {
            jQuery.ajax({
              type: "POST",
              url: cartAddUrl,
              data: payload,
              dataType: "json",
              timeout: cartRequestTimeout,
            })
              .done(resolve)
              .fail(function (XMLHttpRequest, textStatus, errorThrown) {
                reject({
                  xhr: XMLHttpRequest,
                  textStatus: textStatus,
                  errorThrown: errorThrown,
                });
              });
          });
        },
      });
      form.data("cartAddRequest", addTicket.mutation);
      addTicket.mutation
        .then(handleAddToCartSuccess)
        .catch(function (error) {
          focusElement = "";
          showAddToCartError(error && error.xhr ? error.xhr : error);
        })
        .then(finishAddToCart, finishAddToCart);
    });

    // Update quantity based on input on change

    $(document).on("click", ".quantity-button", function (evt) {
      evt.preventDefault();
      var $el = $(this),
        itemKey = String($el.attr("data-id") || ""),
        line = Number($el.attr("data-line")),
        $qtySelector = $el.closest(".quantity").find(".ajaxcart__qty-num");
      var rawQuantity = String($qtySelector.val() || "").trim();
      if (
        !Number.isInteger(line) ||
        line < 1 ||
        !/^\d+$/.test(rawQuantity)
      ) {
        return;
      }
      var qty = Number(rawQuantity);

      // Add or subtract from the current quantity
      if ($el.hasClass("ajaxcart__qty--plus")) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }
      $qtySelector.val(qty);
      updateQuantity(itemKey, line, qty, buildCart, "delta");
    });

    // Update quantity based on input on change
    $(document).on("change", ".ajaxcart__qty-num", function (evt) {
      evt.preventDefault();
      var $el = $(this),
        itemKey = String($el.attr("data-id") || ""),
        line = Number($el.attr("data-line")),
        rawQuantity = String($el.val() || "").trim();
      if (
        !Number.isInteger(line) ||
        line < 1 ||
        !/^\d+$/.test(rawQuantity)
      ) {
        return;
      }
      var qty = Number(rawQuantity);

      // If it has a data-line, update the cart
      updateQuantity(itemKey, line, qty, buildCart, "absolute");
    });

    function openCartDrawer(element) {
      var coordinator = window.LumaryCartCoordinator;
      var generation = coordinator.beginManualDrawerOpen(element);
      var syncStatus = coordinator.getSyncStatus();
      if (syncStatus && (syncStatus.syncing || syncStatus.blocked)) {
        coordinator.notifyDrawerOpen(element, generation);
        return jQuery.Deferred().resolve(null).promise();
      }
      var drawerRequest = requestCartDrawer(
        true,
        element,
        true,
        generation
      );
      drawerRequest.always(function () {
        coordinator.notifyDrawerOpen(element, generation);
      });
      return drawerRequest;
    }
    $("body").on("click", ".openCartDrawer", function (e) {
      e.preventDefault();
      openCartDrawer($(this));
    });

    $("body").on("keydown", ".openCartDrawer", function (e) {
      if (e.code.toUpperCase() === "SPACE") {
        e.preventDefault();
        openCartDrawer($(this));
      }
    });

    $(document).on("click", "[data-cart-drawer-retry]", function (evt) {
      evt.preventDefault();
      var retryButton = jQuery(this);
      var retryAfter = Number(retryButton.attr("data-cart-retry-after"));
      if (
        retryButton.prop("disabled") ||
        (Number.isFinite(retryAfter) && Date.now() < retryAfter)
      ) {
        return;
      }
      window.LumaryCartCoordinator.clearExpiredBlock();
      var retryGeneration = window.LumaryCartCoordinator.beginManualDrawerOpen(
        retryButton
      );
      window.LumaryCartCoordinator.holdRefresh("drawer-manual-retry");
      retryButton.prop("disabled", true).attr("aria-busy", "true");
      requestCartDrawer(
        true,
        retryButton,
        false,
        retryGeneration
      )
        .fail(function (XMLHttpRequest, textStatus) {
          if (textStatus !== "abort") {
            window.LumaryCartCoordinator.reportFailure(
              XMLHttpRequest,
              textStatus
            );
          }
        })
        .always(function () {
          window.LumaryCartCoordinator.releaseRefresh(
            "drawer-manual-retry"
          );
          if (document.documentElement.contains(retryButton[0])) {
            retryButton.prop("disabled", false).removeAttr("aria-busy");
          }
        });
    });

    $(document).on("click", ".sd_mini_removeproduct", function (evt) {
      evt.preventDefault();
      var $el = $(this),
        itemKey = String($el.attr("data-id") || ""),
        line = parseInt($el.attr("data-line"));
      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(itemKey, line, 0, buildCart, "absolute");
      }
    });

    $(document).on("click", "[data-clear-cart]", function (evt) {
      evt.preventDefault();
      openCartClearDialog(this);
    });

    $(document).on("click", ".cartDrawerNote", function () {
      var trigger = $(this);
      var textArea = trigger.siblings(".cartNoteContainer");
      var expanded = trigger.attr("aria-expanded") !== "true";
      trigger.toggleClass("active", expanded).attr("aria-expanded", String(expanded));
      if (expanded) {
        textArea.removeAttr("hidden").hide().slideDown();
      } else {
        textArea.stop(true, true).slideUp(function () {
          textArea.attr("hidden", true);
        });
      }
    });
  }

}

$("body").on("click", "#GiftWrapProduct", function () {
  var giftWrapControl = jQuery(this);
  if (giftWrapControl.attr("aria-busy") === "true") {
    return;
  }
  var giftWrapGeneration = window.LumaryCartCoordinator.beginUserCartBatch();
  var originalDisabled = giftWrapControl.prop("disabled");
  var isCartPage = window.location.pathname.indexOf("/cart") > -1;
  giftWrapControl.prop("disabled", true).attr("aria-busy", "true");
  var giftWrapTicket = window.LumaryCartCoordinator.enqueue({
    source: "gift-wrap",
    showCart: !isCartPage,
    visibilityGeneration: giftWrapGeneration,
    expectedItemCountDelta: 1,
    execute: function () {
      return new Promise(function (resolve, reject) {
        jQuery.ajax({
          type: "POST",
          url: cartAddUrl,
          data: {
            id: parseInt(giftWrapControl.attr("data-product")),
            quantity: 1,
          },
          dataType: "json",
          timeout: cartRequestTimeout,
        })
          .done(resolve)
          .fail(function (XMLHttpRequest, textStatus, errorThrown) {
            reject({
              xhr: XMLHttpRequest,
              textStatus: textStatus,
              errorThrown: errorThrown,
            });
          });
      });
    },
  });
  giftWrapTicket.mutation.catch(function () {});
  giftWrapTicket.refreshed.then(function (cart) {
    if (cart && isCartPage) {
      cartPageUpdate(cart);
    }
    giftWrapControl
      .prop("disabled", originalDisabled)
      .removeAttr("aria-busy");
  });
});

cartPageUpdate = function (cart) {
  return $.ajax({
    url: mainCartUrl,
    type: "GET",
    dataType: "html",
    success: function (result) {
      $("body")
        .find("[data-cart-wrapper]")
        .html($(result).find("[data-cart-wrapper]").html());
      $(".cart-section").find("a:first").trigger("focus");
      freeShippingBar(cart);
     upsellCartProducts(cart)
      window.shippingEstimates();
      // $('body').find('[data-cart-items]').html($(result).find('[data-cart-items]').html());
      // $("body").find("[data-cart-items]").removeClass('disabled');
      // if (cart.item_count == 0) {
      //     emptyCartStatus = true;
      //     $('[data-cart-count').hide();
      //     $('.cart-section').find('a:first').trigger('focus');
      // } else {
      //     emptyCartStatus = false;
      //     $('body').find('[data-cart-items]').find('a:first').trigger('focus');
      // }
      // $('[data-cart-item-count]').text(cart.item_count);
      // $('[data-cart-original-price]').text(Shopify.formatMoney(cart.original_total_price, moneyFormat));
      // $('[data-cart-total-price]').text(Shopify.formatMoney(cart.total_price, moneyFormat));
      // if (cart.cart_level_discount_applications.length > 0) {
      //     var discounts = '';
      //     $.each(cart.cart_level_discount_applications, function(index, discount) {
      //         discounts += '<li data-cart-discount>Discount[' + discount.title + '] <strong>-' + Shopify.formatMoney(discount.total_allocated_amount, moneyFormat) + '</strong></li>';
      //     })
      //     $('li[data-cart-discount]').remove();
      //     $('li[data-cart-original]').removeClass('hidden');
      //     $(discounts).insertAfter('li[data-cart-original]')
      // } else {
      //     $('li[data-cart-original]').addClass('hidden');
      //     $('li[data-cart-discount]').remove();
      // }
      if (animationStatus) {
        if (AOS) {
          AOS.refreshHard();
        }
      }
    },
  });
};

buildCart = function (cart, showCart, element, generation) {
  if (cart.item_count === 0) {
    emptyCartStatus = true;
    $("[data-cart-count]").hide();
  } else {
    emptyCartStatus = false;
    $("[data-cart-count]").show();
  }
  cartItemsCount = cart.item_count;
  if(cartItemsCount > 0 && cartItemsCount < 100){
  $('[data-cart-count]').text(cart.item_count);
  }
  else{
    $('[data-cart-count]').text('');
  }
  if (favicon) {
    favicon.badge(cartItemsCount);
  }
  var drawerBody = jQuery("[data-drawer-body]");
  var previousHtml = getReusableCartDrawerHtml(drawerBody.html());
  if (isCartDrawerHtml(previousHtml)) {
    lastSuccessfulDrawerHtml = previousHtml;
  }
  if (drawerRenderState) {
    drawerRenderState.abort();
  }
  var deferred = jQuery.Deferred();
  var renderRequest = jQuery.ajax({
    url: getCartDrawerSectionUrl(),
    type: "GET",
    dataType: "json",
    cache: false,
    timeout: cartRequestTimeout,
  });
  var state = {
    abort: function () {
      if (renderRequest.readyState !== 4) {
        renderRequest.abort();
      }
    },
  };
  state.promise = deferred.promise();
  state.promise.abort = state.abort;
  drawerRenderState = state;
  renderRequest
    .done(function (response) {
      if (drawerRenderState !== state) {
        deferred.reject(null, "abort");
        return;
      }
      var sectionResult = getCartDrawerSectionResult(response);
      var html = sectionResult && sectionResult.html;
      if (!sectionResult || !isCartDrawerHtml(html)) {
        var parserFailureType = isCartChallengeResponse({
          responseText: typeof response === "string" ? response : "",
          status: 200,
        }) ? "challenge" : "request";
        restoreCartDrawerAfterFailure(
          showCart,
          element,
          previousHtml,
          getCartFailureMessage(parserFailureType),
          parserFailureType,
          generation
        );
        deferred.reject(null, "parsererror");
        return;
      }
      try {
        applyCartDrawerHtml(
          sectionResult,
          cart,
          showCart,
          element,
          generation
        );
        deferred.resolve({
          html: html,
          itemCount: sectionResult.itemCount,
        });
      } catch (error) {
        deferred.reject(null, "rendererror", error);
      }
    })
    .fail(function (XMLHttpRequest, textStatus) {
      if (textStatus !== "abort" && drawerRenderState === state) {
        var failureType = classifyCartRequestFailure(
          XMLHttpRequest,
          textStatus
        );
        restoreCartDrawerAfterFailure(
          showCart,
          element,
          previousHtml,
          getCartFailureMessage(failureType, XMLHttpRequest),
          failureType,
          generation
        );
      }
      deferred.reject(XMLHttpRequest, textStatus);
    })
    .always(function () {
      if (drawerRenderState === state) {
        drawerRenderState = null;
      }
    });
  return state.promise;
};

$(document).on("click","[data-drawer-side-header]",function(){
  if($(this).closest(".yv-upsell-drawer").hasClass("active")){
    $(this).closest(".yv-upsell-drawer").removeClass("active")
  }else{
     $(this).closest(".yv-upsell-drawer").addClass("active")
  }
})

function upsellCartDrawerProducts(cart) {
  if(cart.item_count != 0){
    if(document.querySelector("[data-drawer-side-content]")){
      let upsellContainer=document.querySelector("[data-drawer-side-content]");
      let intent=upsellContainer.getAttribute("data-related-products");
      if(intent != "product-list"){
        let productId=cart.items[0].product_id; 
        let limit=upsellContainer.getAttribute("data-limit");
        fetch(window.Shopify.routes.root + "recommendations/products?product_id="+productId+"&limit="+limit+"&section_id=upsell-products&intent="+intent)
         .then(response => response.text())
         .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('#product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
               upsellContainer.innerHTML = recommendations.innerHTML;
                document.querySelector(".yv-upsell-drawer").classList.remove('hidden')
            }else{
              document.querySelector(".yv-upsell-drawer").classList.add('hidden')
            }
         });
      }
      else{
        if(upsellContainer.children.length > 0){
          document.querySelector(".yv-upsell-drawer").classList.remove('hidden')
        }
        else{
          document.querySelector(".yv-upsell-drawer").classList.add('hidden')
        }
      }
    }  
  }
}

function upsellCartProducts(cart) {
  if(cart.item_count != 0){
    if(document.querySelector("[data-cart-upsell-wrapper]")){
      let upsellWrapper=document.querySelector("[data-cart-upsell-wrapper]");
      let upsellContainer=upsellWrapper.querySelector("[data-cart-upsell]");
      let intent=upsellWrapper.getAttribute("data-related-products");
      if(intent != "product-list"){
        let productId=cart.items[0].product_id; 
        let limit=upsellWrapper.getAttribute("data-limit");
        fetch(window.Shopify.routes.root + "recommendations/products?product_id="+productId+"&limit="+limit+"&section_id=upsell-products&intent="+intent)
         .then(response => response.text())
         .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('#product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              if(window.innerWidth >= 768 ){
                if(upsellContainer.classList.contains('flickity-enabled')){
                  let slider = Flickity.data(upsellContainer);
                  if(slider){
                    slider.destroy();
                     upsellContainer.innerHTML = recommendations.innerHTML;
                    upsellWrapper.classList.remove('hidden')
                    flickitySlider(jQuery(upsellContainer));
                  }
                }
                else{
                    upsellContainer.innerHTML = recommendations.innerHTML;
                    upsellWrapper.classList.remove('hidden')
                    flickitySlider(jQuery(upsellContainer));
                }
              }
              else{
                  upsellContainer.innerHTML = recommendations.innerHTML;
                  upsellWrapper.classList.remove('hidden')
              }
            }else{
              upsellWrapper.classList.add('hidden')
            }
         });
      }
      else{
        if(upsellContainer.classList.contains('flickity-enabled')){
            let slider = Flickity.data(upsellContainer);
            if(slider){
              slider.destroy();
            }
        }
        if(upsellContainer.children.length > 0){
          if(window.innerWidth >= 768 ){
              upsellWrapper.classList.remove('hidden')
              flickitySlider(jQuery(upsellContainer));
          }
          else{
              upsellWrapper.classList.remove('hidden')
          }
        }
        else{
          upsellWrapper.classList.add('hidden')
        }
      }
    }  
  }
}

function cartSyncLabelsWithFallback() {
  return {
    progress: typeof cartSyncProgressLabel === "string" && cartSyncProgressLabel
      ? cartSyncProgressLabel
      : "Packing up your items...... [confirmed] of [total] products added",
    partial: typeof cartSyncPartialFailureLabel === "string" && cartSyncPartialFailureLabel
      ? cartSyncPartialFailureLabel
      : "Packing up your items...... [confirmed] of [total] products added; [failed] failed.",
    pending: typeof cartSyncingLabel === "string" && cartSyncingLabel
      ? cartSyncingLabel
      : "Packing up your items......",
    complete: typeof cartSyncCompleteLabel === "string" && cartSyncCompleteLabel
      ? cartSyncCompleteLabel
      : "Selected items added to cart!",
  };
}

function formatCartSyncLabel(status) {
  var labels = cartSyncLabelsWithFallback();
  if (status.progressTotal > 0) {
    var template = status.progressFailed > 0 ? labels.partial : labels.progress;
    return template
      .replace("[confirmed]", String(Math.min(status.progressConfirmed, status.progressTotal)))
      .replace("[total]", String(status.progressTotal))
      .replace("[failed]", String(status.progressFailed));
  }
  return labels.pending;
}

function setCartCheckoutSyncing(disabled, descriptionId) {
  var checkout = jQuery(".mini_cart .checkout-btn");
  if (!checkout.length) {
    return;
  }
  checkout.each(function () {
    var link = this;
    if (disabled) {
      if (!link.__lumaryCartCheckoutState) {
        link.__lumaryCartCheckoutState = {
          href: link.getAttribute("href"),
          tabindex: link.getAttribute("tabindex"),
          describedby: link.getAttribute("aria-describedby"),
          title: link.getAttribute("title"),
        };
      }
      var describedby = [
        link.__lumaryCartCheckoutState.describedby,
        descriptionId,
      ].filter(Boolean).join(" ");
      link.removeAttribute("href");
      link.setAttribute("tabindex", "-1");
      link.setAttribute("aria-disabled", "true");
      if (describedby) {
        link.setAttribute("aria-describedby", describedby);
      }
      if (typeof cartCheckoutWaitLabel === "string") {
        link.setAttribute("title", cartCheckoutWaitLabel);
      }
      link.classList.add("cart-checkout-syncing");
      return;
    }
    var original = link.__lumaryCartCheckoutState;
    if (original) {
      ["href", "tabindex", "aria-describedby", "title"].forEach(function (name) {
        var key = name === "aria-describedby" ? "describedby" : name;
        if (original[key] === null) {
          link.removeAttribute(name);
        } else {
          link.setAttribute(name, original[key]);
        }
      });
      delete link.__lumaryCartCheckoutState;
    }
    link.removeAttribute("aria-disabled");
    link.classList.remove("cart-checkout-syncing");
  });
}

var cartSyncBatchObserved = false;
var cartSyncActivityObserved = false;
var cartSyncTerminalMessage = "";
var cartSyncLastProgress = {
  confirmed: 0,
  failed: 0,
  total: 0,
};

function updateCartSyncBanner() {
  if (typeof cartDrawerEnable === "undefined" || !cartDrawerEnable) {
    return;
  }
  var drawer = jQuery("[data-side-drawer]").first();
  if (!drawer.length || !drawer.hasClass("mini_cart")) {
    drawer.find("[data-cart-sync-status]")
      .attr("hidden", true)
      .find("[data-cart-sync-message]")
      .text("");
    drawer.find("[data-drawer-body]").removeAttr("aria-busy");
    return;
  }
  var drawerBody = jQuery("[data-drawer-body]").first();
  var statusRegion = drawer.find("[data-cart-sync-status]").first();
  if (!drawerBody.length || !statusRegion.length) {
    return;
  }
  if (
    !window.LumaryCartCoordinator ||
    typeof window.LumaryCartCoordinator.getSyncStatus !== "function"
  ) {
    return;
  }
  var status = window.LumaryCartCoordinator.getSyncStatus();
  if (!status || !status.syncing) {
    drawerBody.removeAttr("aria-busy");
    setCartCheckoutSyncing(
      !!(status && status.blocked),
      status && status.blocked ? "CartDrawerRecoveryError" : ""
    );
    if (status && status.blocked) {
      cartSyncBatchObserved = false;
      cartSyncActivityObserved = false;
      cartSyncTerminalMessage = "";
      statusRegion.attr("hidden", true).removeClass("cart-sync-banner--complete");
      statusRegion.find("[data-cart-sync-message]").text("");
      return;
    }
    if (cartSyncBatchObserved) {
      if (
        cartSyncLastProgress.total > 0 &&
        cartSyncLastProgress.confirmed + cartSyncLastProgress.failed >=
          cartSyncLastProgress.total
      ) {
        if (cartSyncLastProgress.failed > 0) {
          cartSyncTerminalMessage = formatCartSyncLabel({
            progressConfirmed: cartSyncLastProgress.confirmed,
            progressFailed: cartSyncLastProgress.failed,
            progressTotal: cartSyncLastProgress.total,
          });
        } else {
          cartSyncTerminalMessage = cartSyncLabelsWithFallback().complete;
        }
      }
      cartSyncBatchObserved = false;
    }
    if (cartSyncActivityObserved && !cartSyncTerminalMessage) {
      cartSyncTerminalMessage = cartSyncLabelsWithFallback().complete;
    }
    cartSyncActivityObserved = false;
    if (cartSyncTerminalMessage) {
      statusRegion
        .removeAttr("hidden")
        .addClass("cart-sync-banner--complete");
      statusRegion.find("[data-cart-sync-message]").text(cartSyncTerminalMessage);
      return;
    }
    statusRegion.attr("hidden", true).removeClass("cart-sync-banner--complete");
    statusRegion.find("[data-cart-sync-message]").text("");
    return;
  }
  cartSyncActivityObserved = true;
  cartSyncTerminalMessage = "";
  if (status.progressTotal > 0) {
    cartSyncBatchObserved = true;
    cartSyncLastProgress = {
      confirmed: status.progressConfirmed,
      failed: status.progressFailed,
      total: status.progressTotal,
    };
  }
  statusRegion.removeAttr("hidden");
  var message = formatCartSyncLabel(status);
  statusRegion.removeClass("cart-sync-banner--complete");
  var messageTarget = statusRegion.find("[data-cart-sync-message]");
  if (messageTarget.text() !== message) {
    messageTarget.text(message);
  }
  drawerBody.attr("aria-busy", "true");
  setCartCheckoutSyncing(true, "CartDrawerSyncStatus");
}

function updateOptimisticCartCount() {
  if (
    !window.LumaryCartCoordinator ||
    typeof window.LumaryCartCoordinator.getSyncStatus !== "function"
  ) {
    return;
  }
  var status = window.LumaryCartCoordinator.getSyncStatus();
  if (!status) {
    return;
  }
  if (status.total <= 0) {
    jQuery("[data-cart-count]").text("").toggle(false);
    return;
  }
  jQuery("[data-cart-count]")
    .text(status.total > 0 && status.total < 100 ? String(status.total) : "")
    .toggle(true);
}

document.documentElement.addEventListener("cart:pending-changed", function () {
  updateOptimisticCartCount();
  updateCartSyncBanner();
});

document.documentElement.addEventListener("cart:updated", function () {
  updateOptimisticCartCount();
  updateCartSyncBanner();
});

document.documentElement.addEventListener("cart:drawer-closed", function () {
  if (
    window.LumaryCartCoordinator &&
    typeof window.LumaryCartCoordinator.notifyDrawerClosed === "function"
  ) {
    window.LumaryCartCoordinator.notifyDrawerClosed();
  }
});

jQuery(document).on(
  "click",
  ".mini_cart .checkout-btn[aria-disabled='true']",
  function (evt) {
    evt.preventDefault();
  }
);

var cartBodyDrawerOpen = jQuery("body").hasClass("side_Drawer_open");
new MutationObserver(function () {
  var isOpen = jQuery("body").hasClass("side_Drawer_open");
  jQuery("[data-side-drawer]")
    .first()
    .attr("aria-hidden", isOpen ? "false" : "true")
    .each(function () {
      if (isOpen) {
        jQuery(this).removeAttr("inert");
      } else {
        jQuery(this).attr("inert", "");
      }
    });
  if (
    cartBodyDrawerOpen &&
    !isOpen &&
    window.LumaryCartCoordinator &&
    typeof window.LumaryCartCoordinator.notifyDrawerClosed === "function" &&
    jQuery("[data-side-drawer]").first().hasClass("mini_cart")
  ) {
    window.LumaryCartCoordinator.notifyDrawerClosed();
  }
  cartBodyDrawerOpen = isOpen;
}).observe(document.body, { attributes: true, attributeFilter: ["class"] });
